const ON_CHANGE_DEBOUNCE_TIMER = 300;
const currentDate = new Date();
const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  optionValueSelectionChange: "option-value-selection-change",
  variantChange: "variant-change",
  cartError: "cart-error",
};
const POST_LINK_INT = "xml_eval";
let subscribers = {};
function subscribe($, t) {
  if (subscribers[$] === undefined) {
    subscribers[$] = [];
  }
  subscribers[$] = [...subscribers[$], t];
  return function x() {
    subscribers[$] = subscribers[$].filter(($) => $ !== t);
  };
}
function publish($, t) {
  if (subscribers[$]) {
    subscribers[$].forEach(($) => {
      $(t);
    });
  }
}
const GIFTS_LOCAL_STORAGE_KEY = "hdl_gift_goals";
let shouldCheckHdlGifts = false;
let giftsToMonitor = [];
function initHdlGiftsCheck($ = false) {
  let x = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
  if ($) {
    x = document.querySelector("cart-items");
  }
  if (!x || x.dataset.giftsStorage !== "true") {
    return;
  }
  let e = localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY);
  if (!e) {
    return;
  }
  let i = JSON.parse(e);
  if (i && typeof i === "object") {
    Object.values(i).forEach(($) => {
      let i = x.querySelector(".cart-item--product-" + $.gift_handle);
      if (!i) {
        return;
      }
      let s = document.querySelector(".gift--product-" + $.gift_handle);
      if (!s) {
        shouldCheckHdlGifts = true;
        giftsToMonitor.push($);
      }
    });
    updateGiftStyles();
    checkHdlGifts($);
  }
}
function updateGiftStyles() {
  let t = document.getElementById("hdl-gifts-style");
  if (t) {
    t.remove();
  }
  if (!giftsToMonitor.length) {
    return;
  }
  let x = document.createElement("style");
  x.id = "hdl-gifts-style";
  let e = giftsToMonitor
    .map((t) => ".cart-item--product-" + t.gift_handle + " .quantity { display: none !important; }")
    .join("\n");
  x.textContent = e;
  document.head.appendChild(x);
}
function checkHdlGifts($ = false) {
  let x = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
  if ($) {
    x = document.querySelector("cart-items");
  }
  if (shouldCheckHdlGifts && x && x.updateQuantity) {
    for (let e of giftsToMonitor) {
      let i = x.querySelector(".cart-item--product-" + e.gift_handle);
      if (!i) {
        let s = giftsToMonitor.findIndex(($) => $.gift_handle === e.gift_handle);
        if (s > -1) {
          giftsToMonitor.splice(s, 1);
        }
        removeLocalStorageGift(e);
        continue;
      }
      let a = false;
      if (e.type === "product_quantity") {
        let r = 0;
        x.querySelectorAll(".cart-item--product-" + e.unlock_product_handle).forEach(($) => {
          r += parseInt($.dataset.quantity);
        });
        if (r < parseInt(e.required_quantity)) {
          a = true;
        }
      } else if (e.type === "product_variant") {
        let n = x.querySelectorAll(".cart-item--product-" + e.unlock_product_handle);
        if (n.length) {
          let l = Array.isArray(e.valid_variants) ? e.valid_variants : [];
          let h = false;
          let c = false;
          n.forEach(($) => {
            let e = $.dataset.variantOptions;
            if (e) {
              c = true;
              let i = e.split("|||").map(($) => $.trim().toLowerCase());
              if (i.some(($) => l.includes($))) {
                h = true;
              }
            }
          });
          if (c && !h) {
            a = true;
          }
        } else {
          a = true;
        }
      } else {
        let d = parseInt(x.dataset.subtotal);
        if (d < parseInt(e.required_quantity)) {
          a = true;
        }
      }
      if (a) {
        let o = giftsToMonitor.findIndex(($) => $.gift_handle === e.gift_handle);
        if (o > -1) {
          giftsToMonitor.splice(o, 1);
        }
        removeLocalStorageGift(e);
        let f = i.dataset.index ?? i.id.replace("CartItem-", "");
        x.updateQuantity(f, 0);
        return;
      }
    }
  }
}
function validateSingleQuantityCartItems($, t) {
  for (let [e, i] of Object.entries(t)) {
    let s = $.querySelectorAll(".cart-item--product-" + e);
    if (s.length !== 0) {
      if (s.length > 1) {
        let a = null;
        let r = [];
        s.forEach(($) => {
          let e = $.querySelector("[data-quantity-variant-id]");
          let s = e ? e.dataset.quantityVariantId : null;
          if (s !== i || a) {
            r.push($);
          } else {
            a = $;
          }
        });
        if (!a && r.length > 0) {
          a = r.shift();
        }
        if (r.length > 0) {
          let n = r[0];
          let l = n.dataset.index ?? n.id.replace("CartItem-", "").replace("CartDrawer-Item-", "");
          $.updateQuantity(l, 0);
          return true;
        }
      }
      if (s.length === 1) {
        let h = s[0];
        let c = parseInt(h.dataset.quantity) || 1;
        if (c > 1) {
          let d = h.dataset.index ?? h.id.replace("CartItem-", "").replace("CartDrawer-Item-", "");
          $.updateQuantity(d, 1);
          return true;
        }
      }
    }
  }
  return false;
}
function validateCartGifts($ = false) {
  let x = document.querySelector("cart-drawer");
  if (!x) {
    return;
  }
  let e = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
  if ($) {
    e = document.querySelector("cart-items");
  }
  if (!e || !e.updateQuantity) {
    return;
  }
  let i = x.querySelectorAll("cart-drawer-gift");
  let s = x.querySelectorAll('cart-drawer-upsell[data-toggle="true"]');
  if (!i.length && !s.length) {
    return;
  }
  let a = {};
  i.forEach(($) => {
    if ($.dataset.handle && $.dataset.id && $.dataset.selected === "true") {
      a[$.dataset.handle] = $.dataset.id;
    }
  });
  let r = {};
  s.forEach(($) => {
    if ($.dataset.handle && $.dataset.id && $.dataset.selected === "true") {
      r[$.dataset.handle] = $.dataset.id;
    }
  });
  if (!validateSingleQuantityCartItems(e, a) && validateSingleQuantityCartItems(e, r)) {
    return;
  }
}
function removeLocalStorageGift($) {
  let t = localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY);
  if (t) {
    try {
      let x = JSON.parse(t);
      if (x && x[$.gift_handle]) {
        delete x[$.gift_handle];
        localStorage.setItem(GIFTS_LOCAL_STORAGE_KEY, JSON.stringify(x));
      }
    } catch (e) {
      console.warn("Error parsing gift localStorage data:", e);
    }
  }
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (t) => {
      t.preventDefault();
      if (this.dataset.handle) {
        let e = this.dataset.handle;
        let i = document.querySelectorAll('.quantity-break__upsell[data-handle="' + e + '"]');
        i.forEach(($) => {
          $.dataset.selected = "false";
          $.classList.remove("quantity-break__upsell--selected");
          let e = $.querySelector('input[type="checkbox"]');
          if (e) {
            e.checked = false;
          }
        });
      }
      let s = this.closest("cart-items") || this.closest("cart-drawer-items");
      if (this.clearCart) {
        s.clearCart();
      } else {
        s.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
var date = "2027-10-10";
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemContainer = formatDates(currentDate, date);
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");
    this.secondCartItems = document.querySelector("cart-drawer-items");
    this.quantityGifts = document.querySelector(".quantity-gifts");
    let t = debounce((t) => {
      this.onChange(t);
    }, 300);
    this.addEventListener("change", t.bind(this));
    this.isCartPage = this.nodeName === "CART-ITEMS";
    this.otherCartItemsSelector = this.isCartPage ? "cart-drawer-items" : "cart-items";
    this.hasOtherCartItems = document.querySelector(this.otherCartItemsSelector) !== null;
    if (this.hasOtherCartItems) {
      if (this.isCartPage) {
        initHdlGiftsCheck(true);
      }
    } else {
      initHdlGiftsCheck(false);
    }
  }
  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (t) => {
      if (t.source !== "cart-items") {
        this.onCartUpdate();
      }
    });
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  onChange($) {
    this.updateQuantity(
      $.target.dataset.index,
      $.target.value,
      document.activeElement.getAttribute("name"),
    );
  }
  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items")
      .then((t) => t.text())
      .then((t) => {
        let e = new DOMParser().parseFromString(t, "text/html");
        let i = e.querySelector("cart-items");
        this.innerHTML = i.innerHTML;
      })
      .catch((t) => {
        console.error(t);
      });
  }
  updateCart() {
    let t = JSON.stringify({
      sections: this.getSectionsToRender().map((t) => t.section),
      sections_url: window.location.pathname,
    });
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: t,
    })
      .then((t) => t.json())
      .then((t) => {
        this.classList.toggle("is-empty", t.item_count === 0);
        this.getSectionsToRender().forEach(($) => {
          let i =
            document.getElementById($.id).querySelector($.selector) ||
            document.getElementById($.id);
          i.innerHTML = this.getSectionInnerHTML(t.sections[$.section], $.selector);
        });
      })
      .catch((t) => {
        console.error(t);
      });
  }
  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }
  async updateQuantity($, t, x) {
    this.enableLoading($);
    let i =
      document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
    if (i) {
      i.textContent = "";
    }
    let s = JSON.stringify({
      line: $,
      quantity: t,
      sections: this.getSectionsToRender().map(($) => $.section),
      sections_url: window.location.pathname,
    });
    try {
      let a = await fetch("" + routes.cart_change_url, {
        ...fetchConfig(),
        body: s,
      });
      let r = await a.text();
      let n = JSON.parse(r);
      let l =
        document.getElementById("Quantity-" + $) || document.getElementById("Drawer-quantity-" + $);
      let h = document.querySelectorAll(".cart-item");
      if (n.errors) {
        l.value = l.getAttribute("value");
        this.updateLiveRegions($, n.errors);
        return;
      }
      if (!n.sections) {
        let c = await fetch(
          routes.cart_url +
            "?sections=" +
            this.getSectionsToRender()
              .map(($) => $.section)
              .join(","),
        );
        n.sections = await c.json();
      }
      this.classList.toggle("is-empty", n.item_count === 0);
      let d = document.querySelector("cart-drawer");
      let o = document.getElementById("main-cart-footer");
      if (o) {
        o.classList.toggle("is-empty", n.item_count === 0);
      }
      if (d) {
        d.classList.toggle("is-empty", n.item_count === 0);
      }
      this.getSectionsToRender().forEach(($) => {
        let x = document.getElementById($.id);
        if (x) {
          let i = x.querySelector($.selector) || x;
          i.innerHTML = this.getSectionInnerHTML(n.sections[$.section], $.selector);
          let s = i.querySelector(".cart-drawer__body");
          if (s && this.cartDrawer) {
            s.scrollTop = this.cartDrawer.cartBodyScroll;
          }
        }
      });
      let f = n.items[$ - 1] ? n.items[$ - 1].quantity : undefined;
      let u = "";
      if (h.length === n.items.length && f !== parseInt(l.value)) {
        u =
          typeof f === "undefined"
            ? window.cartStrings.error
            : window.cartStrings.quantityError.replace("[quantity]", f);
      }
      this.updateLiveRegions($, u);
      let b =
        document.getElementById("CartItem-" + $) || document.getElementById("CartDrawer-Item-" + $);
      if (b && b.querySelector('[name="' + x + '"]')) {
        if (d) {
          trapFocus(d, b.querySelector('[name="' + x + '"]'));
        } else {
          b.querySelector('[name="' + x + '"]').focus();
        }
      } else if (n.item_count === 0 && d) {
        trapFocus(d.querySelector(".drawer__inner-empty"), d.querySelector("a"));
      } else if (document.querySelector(".cart-item") && d) {
        trapFocus(d, document.querySelector(".cart-item__name"));
      }
      if (d) {
        d.checkForClear();
        let p = d.querySelector("countdown-timer");
        if (p) {
          p.playTimer();
        }
        let _ = false;
        if (d.querySelector("cart-drawer-gift")) {
          d.checkForClear();
          let m = [];
          let y = [];
          d.querySelectorAll("cart-drawer-gift").forEach(($) => {
            if ($.getUpdateRequired()) {
              if (d.querySelector(".cart-item--product-" + $.dataset.handle)) {
                if ($.dataset.selected === "false") {
                  y.push($);
                }
              } else if ($.dataset.selected === "true") {
                m.push($);
              }
            }
          });
          if (y.length > 0) {
            _ = true;
            y[0].removeFromCart();
          } else if (m.length > 0) {
            _ = true;
            m[0].addToCart();
          }
        }
        if (this.quantityGifts && !_) {
          this.quantityGifts.initUnlock();
        }
        let g = document.querySelectorAll("quantity-break-upsells");
        g.forEach(($) => {
          if (!_) {
            $.initUnlock();
          }
        });
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items",
        cartData: n,
      });
    } catch (v) {
      console.log(v);
      this.querySelectorAll(".loading-overlay").forEach(($) => $.classList.add("hidden"));
      let S =
        document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      S.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading($);
      if (this.secondCartItems && this.secondCartItems.updateCart) {
        this.secondCartItems.updateCart();
      }
      let k = new CustomEvent("cartQuantityUpdated", {
        detail: {
          handle: "handle",
        },
      });
      document.dispatchEvent(k);
      if (shouldCheckHdlGifts) {
        checkHdlGifts(this.isCartPage);
      }
      validateCartGifts(this.isCartPage);
    }
  }
  updateLiveRegions($, t) {
    let e =
      document.getElementById("Line-item-error-" + $) ||
      document.getElementById("CartDrawer-LineItemError-" + $);
    if (e) {
      e.querySelector(".cart-item__error-text").innerHTML = t;
    }
    this.lineItemStatusElement.setAttribute("aria-hidden", true);
    let i =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    i.setAttribute("aria-hidden", false);
    setTimeout(() => {
      i.setAttribute("aria-hidden", true);
    }, 1000);
  }
  getSectionInnerHTML($, t) {
    return new DOMParser().parseFromString($, "text/html").querySelector(t).innerHTML;
  }
  enableLoading($) {
    let x =
      document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    x.classList.add("cart__items--disabled");
    let e = this.querySelectorAll("#CartItem-" + $ + " .loading-overlay");
    let i = this.querySelectorAll("#CartDrawer-Item-" + $ + " .loading-overlay");
    [...e, ...i].forEach(($) => $.classList.remove("hidden"));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }
  disableLoading($) {
    let x =
      document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    x.classList.remove("cart__items--disabled");
    let e = this.querySelectorAll("#CartItem-" + $ + " .loading-overlay");
    let i = this.querySelectorAll("#CartDrawer-Item-" + $ + " .loading-overlay");
    e.forEach(($) => $.classList.add("hidden"));
    i.forEach(($) => $.classList.add("hidden"));
  }
  clearCart() {
    let t =
      document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
    if (t) {
      t.textContent = "";
    }
    let x = JSON.stringify({
      sections: this.getSectionsToRender().map((t) => t.section),
      sections_url: window.location.pathname,
    });
    fetch("" + routes.cart_clear_url, {
      ...fetchConfig(),
      body: x,
    })
      .then((t) => t.text())
      .then(async (t) => {
        let e = JSON.parse(t);
        if (!e.sections) {
          try {
            let i = this.getSectionsToRender()
              .map(($) => $.id)
              .join(",");
            let s = await fetch(routes.cart_url + "?sections=" + i);
            let a = await s.json();
            e.sections = a;
          } catch (r) {
            console.error("Clear cart fallback failed", r);
            throw r;
          }
        }
        this.classList.add("is-empty");
        let n = document.querySelector("cart-drawer");
        let l = document.getElementById("main-cart-footer");
        if (l) {
          l.classList.add("is-empty");
        }
        if (n) {
          n.classList.add("is-empty");
        }
        this.getSectionsToRender().forEach(($) => {
          let i =
            document.getElementById($.id).querySelector($.selector) ||
            document.getElementById($.id);
          i.innerHTML = this.getSectionInnerHTML(e.sections[$.section], $.selector);
        });
        if (n) {
          trapFocus(n.querySelector(".drawer__inner-empty"), n.querySelector("a"));
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
        });
        if (shouldCheckHdlGifts) {
          checkHdlGifts(this.isCartPage);
        }
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach(($) => $.classList.add("hidden"));
        let x =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        x.textContent = window.cartStrings.error;
      });
  }
}
customElements.define("cart-items", CartItems);
var search = "search";
function handleDiscountForm($) {
  $.preventDefault();
  let x = $.target.querySelector("[name=cart-discount-field]");
  let e = $.target.querySelector(".cart-discount-form__error");
  let i = x.value;
  if (i === undefined || i.length === 0) {
    e.style.display = "block";
    return;
  }
  e.style.display = "none";
  let s = "/checkout?discount=";
  window.location.href = s + i;
}
function handleDiscountFormChange($) {
  let x = document.querySelectorAll(".cart-discount-form__error");
  x.forEach(($) => {
    $.style.display = "none";
  });
}
if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class $ extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          "change",
          debounce((t) => {
            let e = JSON.stringify({
              note: t.target.value,
            });
            fetch("" + routes.cart_update_url, {
              ...fetchConfig(),
              body: e,
            });
          }, 300),
        );
      }
    },
  );
}
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener(
        "input",
        debounce((t) => {
          this.onChange(t);
        }, 300).bind(this),
      );
    }
  }
  toggleResetButton() {
    let t = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && t) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !t) {
      this.resetButton.classList.add("hidden");
    }
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }
  onFormReset($) {
    $.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    }
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    let t = this.getQuery();
    if (!this.searchTerm || !t.startsWith(this.searchTerm)) {
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }
    this.updateSearchForTerm(this.searchTerm, t);
    this.searchTerm = t;
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit($) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
      $.preventDefault();
    }
  }
  onFormReset($) {
    super.onFormReset($);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }
  onFocus() {
    let t = this.getQuery();
    if (t.length) {
      if (this.searchTerm !== t) {
        this.onChange();
      } else if (this.getAttribute("results") === "true") {
        this.open();
      } else {
        this.getSearchResults(this.searchTerm);
      }
    }
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }
  onKeyup($) {
    if (!this.getQuery().length) {
      this.close(true);
    }
    $.preventDefault();
    switch ($.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
    }
  }
  onKeydown($) {
    if ($.code === "ArrowUp" || $.code === "ArrowDown") {
      $.preventDefault();
    }
  }
  updateSearchForTerm($, t) {
    let e = this.querySelector("[data-predictive-search-search-for-text]");
    let i = e?.innerText;
    if (i) {
      if (i.match(RegExp($, "g")).length > 1) {
        return;
      }
      let s = i.replace($, t);
      e.innerText = s;
    }
  }
  switchOption($) {
    if (!this.getAttribute("open")) {
      return;
    }
    let x = $ === "up";
    let e = this.querySelector('[aria-selected="true"]');
    let i = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(
      ($) => $.offsetParent !== null,
    );
    let s = 0;
    if (x && !e) {
      return;
    }
    let a = -1;
    let r = 0;
    while (a === -1 && r <= i.length) {
      if (i[r] === e) {
        a = r;
      }
      r++;
    }
    this.statusElement.textContent = "";
    if (!x && e) {
      s = a === i.length - 1 ? 0 : a + 1;
    } else if (x) {
      s = a === 0 ? i.length - 1 : a - 1;
    }
    if (s === a) {
      return;
    }
    let n = i[s];
    n.setAttribute("aria-selected", true);
    if (e) {
      e.setAttribute("aria-selected", false);
    }
    this.input.setAttribute("aria-activedescendant", n.id);
  }
  selectOption() {
    let t = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    if (t) {
      t.click();
    }
  }
  getSearchResults($) {
    let x = $.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[x]) {
      this.renderSearchResults(this.cachedResults[x]);
      return;
    }
    fetch(
      routes.predictive_search_url +
        "?q=" +
        encodeURIComponent($) +
        "&section_id=predictive-search",
      {
        signal: this.abortController.signal,
      },
    )
      .then(($) => {
        if (!$.ok) {
          var e = Error($.status);
          this.close();
          throw e;
        }
        return $.text();
      })
      .then(($) => {
        let i = new DOMParser()
          .parseFromString($, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.allPredictiveSearchInstances.forEach(($) => {
          $.cachedResults[x] = i;
        });
        this.renderSearchResults(i);
      })
      .catch(($) => {
        if ($?.code !== 20) {
          this.close();
          throw $;
        }
      });
  }
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }
  setLiveRegionText($) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = $;
    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }
  renderSearchResults($) {
    this.predictiveSearchResults.innerHTML = $;
    this.setAttribute("results", true);
    this.setLiveRegionResults();
    this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(
      this.querySelector("[data-predictive-search-live-region-count-value]").textContent,
    );
  }
  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
  open() {
    this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || this.getResultsMaxHeight() + "px";
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
  }
  close($ = false) {
    this.closeResults($);
    this.isOpen = false;
  }
  closeResults($ = false) {
    if ($) {
      this.input.value = "";
      this.removeAttribute("results");
    }
    let x = this.querySelector('[aria-selected="true"]');
    if (x) {
      x.setAttribute("aria-selected", false);
    }
    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
const defMed = "data-defer";
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.upsellHandles = this.getUpsellHandles();
    this.quantityGifts = document.querySelector(".quantity-gifts");
    this.checkForClear();
    this.addEventListener("keyup", (t) => t.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.cartBodyScroll = 0;
  }
  setHeaderCartIconAccessibility() {
    let t = document.querySelector("#cart-icon-bubble");
    if (!t || (t.tagName == "DIV" && (t = t.closest(".header__icon--cart")), !t)) {
      return;
    }
    let x = t.closest(".header__icons");
    t.setAttribute("role", "button");
    t.setAttribute("aria-haspopup", "dialog");
    t.addEventListener("click", (x) => {
      x.preventDefault();
      this.open(t);
    });
    this.oseid = x.querySelector("form").dataset[this.dataset.type];
    t.addEventListener("keydown", (x) => {
      if (x.code.toUpperCase() === "SPACE") {
        x.preventDefault();
        this.open(t);
      }
    });
  }
  open($) {
    if ($) {
      this.setActiveElement($);
    }
    let x = this.querySelector('[id^="Details-"] summary');
    if (x && !x.hasAttribute("role")) {
      this.setSummaryAccessibility(x);
    }
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener(
      "transitionend",
      () => {
        let x = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        let e = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
        trapFocus(x, e);
      },
      {
        once: true,
      },
    );
    document.body.classList.add("overflow-hidden");
    let e = this.querySelector("countdown-timer");
    if (e) {
      e.playTimer();
    }
  }
  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    let t = this.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
    let x = [];
    t.forEach((t) => {
      if (t.dataset.handle) {
        x.push(t.dataset.handle);
      }
    });
    return x;
  }
  oneNonUpellRemaining() {
    let t = this.querySelectorAll(".cart-item");
    let x = 0;
    t.forEach((t) => {
      this.upsellHandles.forEach(($) => {
        if (t.classList.contains("cart-item--product-" + $)) {
          x++;
        }
      });
    });
    return t.length - x <= 1;
  }
  checkForClear() {
    let t = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach((x) => {
      if (t) {
        x.clearCart = true;
      } else {
        x.clearCart = false;
      }
    });
  }
  setSummaryAccessibility($) {
    $.setAttribute("role", "button");
    $.setAttribute("aria-expanded", "false");
    if ($.nextElementSibling.getAttribute("id")) {
      $.setAttribute("aria-controls", $.nextElementSibling.id);
    }
    $.addEventListener("click", ($) => {
      $.currentTarget.setAttribute(
        "aria-expanded",
        !$.currentTarget.closest("details").hasAttribute("open"),
      );
    });
    $.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents($, t = false) {
    if (this.querySelector(".drawer__inner").classList.contains("is-empty")) {
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    }
    this.productId = $.id;
    this.getSectionsToRender().forEach((t) => {
      let i = t.selector ? document.querySelector(t.selector) : document.getElementById(t.id);
      if (i) {
        i.innerHTML = this.getSectionInnerHTML($.sections[t.id], t.selector);
        let s = i.querySelector(".cart-drawer__body");
        if (s) {
          s.scrollTop = this.cartBodyScroll;
        }
      }
    });
    this.checkForClear();
    let e = this.querySelector("countdown-timer");
    if (e && e.playTimer) {
      e.playTimer();
    }
    let i = [];
    let s = [];
    this.querySelectorAll("cart-drawer-gift").forEach(($) => {
      if ($.getUpdateRequired()) {
        if (this.querySelector(".cart-item--product-" + $.dataset.handle)) {
          if ($.dataset.selected === "false") {
            s.push($);
          }
        } else if ($.dataset.selected === "true") {
          i.push($);
        }
      }
    });
    if (s.length > 0) {
      s[0].removeFromCart();
    } else if (i.length > 0) {
      i[0].addToCart();
    } else {
      if (this.quantityGifts) {
        this.quantityGifts.initUnlock();
      }
      let a = document.querySelectorAll("quantity-break-upsells");
      a.forEach(($) => {
        $.initUnlock();
      });
    }
    validateCartGifts();
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      if (!t) {
        this.open();
      }
    });
  }
  getSectionInnerHTML($, t = ".shopify-section") {
    let e = new DOMParser().parseFromString($, "text/html").querySelector(t);
    if (t === "#CartDrawer") {
      fixParsedHtml(this, e);
    }
    return e.innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }
  getSectionDOM($, t = ".shopify-section") {
    return new DOMParser().parseFromString($, "text/html").querySelector(t);
  }
  setActiveElement($) {
    this.activeElement = $;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.secondCartItems = document.querySelector("cart-items");
  }
  updateCart() {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname,
      }),
    })
      .then((t) => t.json())
      .then((t) => {
        document.querySelector("cart-drawer").renderContents(t, true);
      })
      .catch((t) => {
        console.error(t);
      });
  }
  getSectionInnerHTML($, t) {
    let e = new DOMParser().parseFromString($, "text/html").querySelector(t);
    if (t === ".drawer__inner") {
      fixParsedHtml(this.cartDrawer, e);
    }
    return e.innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}
function fixParsedHtml($, t) {
  let e = $.querySelector(".cart-drawer__body");
  if (e) {
    let i = document.querySelector("cart-drawer");
    i.cartBodyScroll = e.scrollTop;
  }
  let s = t.querySelector(".cart-timer");
  if (s && (oldTimer = $.querySelector(".cart-timer"))) {
    s.innerHTML = oldTimer.innerHTML;
  }
  let a = $.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
  let r = t.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
  a.forEach(($, t) => {
    let i = r[t];
    if (i) {
      if ($.nodeName.toLowerCase() === "cart-drawer-upsell") {
        i.dataset.selected = $.dataset.selected;
      }
      i.dataset.id = $.dataset.id;
      i.querySelector('[name="id"]').value = $.querySelector('[name="id"]').value;
      if (i.querySelector(".upsell__image__img")) {
        i.querySelector(".upsell__image__img").src = $.querySelector(".upsell__image__img").src;
      }
      if (i.querySelector(".upsell__variant-picker")) {
        let s = $.querySelectorAll(".select__select");
        i.querySelectorAll(".select__select").forEach(($, t) => {
          $.value = s[t].value;
          $.querySelectorAll("option").forEach(($) => {
            $.removeAttribute("selected");
            if ($.value === s[t].value.trim()) {
              $.setAttribute("selected", "");
            }
          });
        });
      }
      if ($.dataset.updatePrices === "true") {
        var a = i.querySelector(".upsell__price");
        var n = $.querySelector(".upsell__price");
        if (a && n) {
          a.innerHTML = n.innerHTML;
        }
      }
    }
  });
}
function serializePropValue($) {
  if ($ == null) {
    return "";
  }
  if (typeof $ === "object") {
    try {
      return JSON.stringify($);
    } catch {}
  }
  return String($);
}
function getFocusableElements($) {
  return Array.from(
    $.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
customElements.define("cart-drawer-items", CartDrawerItems);
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class $ extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.handleSubmit.bind(this));
        this.formIdInput = this.form.querySelector("[name=id]");
        this.formIdInput.disabled = false;
        this.isMain = this.classList.contains("main-product-form");
        this.additionalAtcButtons = this.isMain
          ? document.querySelectorAll(".main-product-atc")
          : [];
        this.skipCart = this.formIdInput.dataset.skipCart === "true";
        this.cart =
          document.querySelector("cart-drawer") || document.querySelector("cart-notification");
        this.isCartUpsell = this.dataset.isCartUpsell === "true";
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer")) {
          if (this.submitButton) {
            this.submitButton.setAttribute("aria-haspopup", "dialog");
          }
          this.hasDrawer = true;
        }
        if (this.submitButton) {
          this.loadingSpinner = this.submitButton.querySelector(".loading-overlay__spinner");
        }
        this.displayedSubmitButton = document.getElementById(
          "DisplayedSubmitBtn-" + this.dataset.section,
        );
        this.bundleDeals = document.getElementById("bundle-deals-" + this.dataset.section);
        this.productInfo = document.getElementById("ProductInfo-" + this.dataset.section);
        this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
        if (this.quantityBreaks) {
          this.quantityBreakUpsells =
            this.quantityBreaks.querySelectorAll("quantity-break-upsells");
        }
        this.quantityPicker = document.getElementById("Quantity-Form-" + this.dataset.section);
        this.customFields = document.querySelectorAll(
          "[id^='CustomField-" + this.dataset.section + "-']",
        );
        this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
        this.mainBundleItems = document.querySelectorAll(
          ".main-offer-item-" + this.dataset.section,
        );
        this.variantInputs = this.form.querySelector(".product-form__variants");
      }
      handleSubmit($) {
        let x = null;
        let e = false;
        if ($) {
          $.preventDefault();
          if ($.currentTarget.classList.contains("button--has-spinner")) {
            (x = $.currentTarget).classList.add("loading");
          }
          if ($.currentTarget.dataset.skipCartButton === "true") {
            e = true;
          }
        }
        if (this.submitButton.getAttribute("aria-disabled") === "true") {
          return;
        }
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        if (!x) {
          this.submitButton.classList.add("loading");
          if (this.loadingSpinner) {
            this.loadingSpinner.classList.remove("hidden");
          }
        }
        this.additionalAtcButtons.forEach(($) => {
          $.setAttribute("disabled", "");
        });
        if (this.displayedSubmitButton) {
          this.displayedSubmitButton.setAttribute("disabled", "");
          this.displayedSubmitButton.classList.add("loading");
        }
        let i = false;
        let s = false;
        if (this.variantInputs && !this.ref) {
          this.variantInputs.innerHTML = "";
          let a = "";
          let r = [];
          let n = new Set();
          let l = ($) => {
            let x = $ == null ? "" : String($).trim();
            if (x === "") {
              return null;
            } else {
              return x;
            }
          };
          let h = ($, x = 1, e = null) => {
            if (!$) {
              return;
            }
            let s = String($);
            let a = Number(x) || 1;
            let n = l(e);
            let h = r.findIndex(($) => {
              let t = l($.selling_plan);
              return $.id === s && t === n;
            });
            if (h === -1) {
              let c = {
                id: s,
                quantity: a,
              };
              if (n) {
                c.selling_plan = n;
              }
              r.push(c);
            } else {
              r[h].quantity += a;
            }
          };
          let c = ($) => {
            if ($) {
              n.add(String($));
            }
          };
          if (!!this.hasDrawer && !this.isCartUpsell && !this.skipCart) {
            this.cart
              .querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift')
              .forEach(($) => {
                if (
                  $.dataset.selected === "true" &&
                  !this.cart.querySelector(".cart-item--product-" + $.dataset.handle)
                ) {
                  let e = $.querySelector('input[name="selling_plan"]')?.value || null;
                  h($.dataset.id, 1, e);
                }
              });
          }
          if (this.bundleDeals) {
            if (this.dataset.includePdpUpsells === "true") {
              document.querySelectorAll("product-info-upsell").forEach(($) => {
                let e = $.querySelector('input[name="selling_plan"]')?.value || null;
                if ($.dataset.selected === "true") {
                  h($.dataset.id, 1, e);
                }
              });
            }
            (this.bundleDeals.formVariants || []).forEach(($) => {
              if ($) {
                h($.id, Number($.quantity) || 1);
              }
            });
          } else {
            if (
              this.quantityGifts &&
              Array.isArray(this.quantityGifts.unlockedItems) &&
              this.quantityGifts.unlockedItems.length > 0
            ) {
              this.quantityGifts.unlockedItems.forEach(($) => h($, 1));
            }
            this.upsells = document.querySelectorAll(
              ".product-info-upsell-" + this.dataset.section,
            );
            for (let d = this.upsells.length - 1; d >= 0; d--) {
              let o = this.upsells[d];
              if (o && o.dataset.selected === "true") {
                let f = o.querySelector('input[name="selling_plan"]')?.value || null;
                h(o.dataset.id, 1, f);
              }
            }
            if (this.quantityBreakUpsells) {
              this.quantityBreakUpsells.forEach(($) => {
                ($.unlockedItems || []).forEach(($) => {
                  let e = String($);
                  if (!r.some(($) => String($.id) === e)) {
                    h(e, 1);
                  }
                });
              });
            }
            if (this.mainBundleItems.length === 0) {
              if (
                this.quantityBreaks &&
                Array.isArray(this.quantityBreaks.formVariants) &&
                this.quantityBreaks.formVariants.length > 0
              ) {
                this.quantityBreaks.formVariants.forEach(($) => {
                  h($, 1);
                  c($);
                });
                s = true;
              } else {
                let u = 1;
                if (this.quantityBreaks) {
                  u = Number(this.quantityBreaks.selectedQuantity) || 1;
                } else if (this.quantityPicker) {
                  u = Number(this.quantityPicker.querySelector(".quantity__input")?.value) || 1;
                } else if (this.querySelector('input[name="quantity"]')) {
                  u = Number(this.querySelector('input[name="quantity"]').value) || 1;
                }
                let b = this.formIdInput.value;
                h(b, u);
                c(b);
              }
            }
            for (let p = this.mainBundleItems.length - 1; p >= 0; p--) {
              let _ = this.mainBundleItems[p];
              h(_.dataset.id, 1);
              if (
                _.dataset.isMainPdpProduct === undefined ||
                _.dataset.isMainPdpProduct === "true"
              ) {
                c(_.dataset.id);
              }
            }
          }
          if (r.length > 1 || s || this.bundleDeals || this.mainBundleItems.length > 0) {
            let m = [];
            this.customFields?.forEach(($) => {
              if ($?.dataset?.disabled !== "true") {
                m.push({
                  fieldName: $.fieldName,
                  value: $.prevValue,
                });
              }
            });
            let y = null;
            if (this.classList.contains("main-product-form")) {
              y =
                this.querySelector('.appstle-active-option [name="selling_plan"]') ||
                this.querySelector('[name="selling_plan"]') ||
                document.querySelector(
                  '.sls-purchase [name="selling_plan"], skio-plan-picker [name="selling_plan"]',
                );
            }
            let g = this.querySelector("#simple-bundles-io-options");
            let v =
              'input[name^="properties["]:not(#validator):not(.hdl-property-input):not([type="radio"]),input[name^="properties["][type="radio"]:checked:not(#validator):not(.hdl-property-input),select[name^="properties["]:not(#validator):not(.hdl-property-input)';
            let S = this.classList.contains("main-product-form")
              ? this.productInfo
                ? this.productInfo.querySelectorAll(v)
                : document.querySelectorAll(v)
              : [];
            r.forEach(($) => {
              if (n.has($.id)) {
                let e = [];
                m.forEach(($) => {
                  e.push({
                    fieldName: $.fieldName,
                    value: $.value,
                  });
                });
                if (g) {
                  g.querySelectorAll(
                    'select[name^="properties["], input[name^="properties["]',
                  ).forEach(($) => {
                    let i = $.name.match(/properties\[(.*?)\]/);
                    if (i) {
                      e.push({
                        fieldName: i[1],
                        value: $.value,
                      });
                    }
                  });
                }
                if (this.classList.contains("main-product-form")) {
                  S.forEach(($) => {
                    let i = $.name.match(/properties\[(.*?)\]/);
                    if (i) {
                      if ($.type === "file") {
                        if ($.files && $.files.length > 0) {
                          e.push({
                            fieldName: i[1],
                            value: $.files[0],
                            isFile: true,
                          });
                        }
                      } else {
                        e.push({
                          fieldName: i[1],
                          value: $.value,
                        });
                      }
                    }
                  });
                }
                if (e.length) {
                  $.properties = e;
                }
                if (y && typeof y.value === "string" && y.value.length > 0) {
                  $.selling_plan = y.value;
                }
              }
            });
            let k = document.createDocumentFragment();
            let T = [];
            r.forEach(($, x) => {
              a +=
                '<input type="hidden" name="items[' +
                x +
                '][quantity]" value="' +
                $.quantity +
                '">' +
                ('<input type="hidden" name="items[' + x + '][id]" value="') +
                $.id +
                '">';
              if ($.selling_plan) {
                a +=
                  '<input type="hidden" name="items[' +
                  x +
                  '][selling_plan]" value="' +
                  $.selling_plan +
                  '">';
              }
              if (Array.isArray($.properties) && $.properties.length) {
                $.properties.forEach(($) => {
                  if ($.isFile) {
                    T.push({
                      name: "items[" + x + "][properties][" + $.fieldName + "]",
                      file: $.value,
                    });
                  } else {
                    let i = document.createElement("input");
                    i.type = "hidden";
                    i.name = "items[" + x + "][properties][" + $.fieldName + "]";
                    i.value = serializePropValue($.value);
                    k.appendChild(i);
                  }
                });
              }
            });
            this._filePropsForFormData = T;
            this.variantInputs.innerHTML = a;
            this.variantInputs.appendChild(k);
            i = true;
          }
        }
        var E = fetchConfig("javascript");
        E.headers["X-Requested-With"] = "XMLHttpRequest";
        delete E.headers["Content-Type"];
        var B = new FormData(this.form);
        if (this._filePropsForFormData && this._filePropsForFormData.length > 0) {
          this._filePropsForFormData.forEach(({ name: $, file: x }) => {
            B.append($, x);
          });
          this._filePropsForFormData = [];
        }
        if (this.ref) {
          i = true;
        }
        if (this.cart) {
          B.append(
            "sections",
            this.cart.getSectionsToRender().map(($) => $.id),
          );
          B.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (i) {
          let C = this.dataset.options ? this.dataset.options.split(",") : [];
          let q = ["id", "quantity", ...C];
          for (let I = 0; I < q.length; I++) {
            B.delete(q[I]);
          }
        }
        E.body = B;
        fetch("" + routes.cart_add_url, E)
          .then(($) => $.json())
          .then(async ($) => {
            if ($.status) {
              this.handleErrorMessage($.description);
              let i = this.submitButton.querySelector(".sold-out-message");
              if (!i) {
                return;
              }
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              i.classList.remove("hidden");
              this.error = true;
              return;
            }
            if (!$.sections && this.cart) {
              try {
                let s = await fetch(
                  routes.cart_url +
                    "?sections=" +
                    this.cart
                      .getSectionsToRender()
                      .map(($) => $.id)
                      .join(","),
                );
                let a = await s.json();
                $.sections = a;
              } catch (r) {
                console.error("Add to cart fallback failed", r);
                this.handleErrorMessage(window.cartStrings.error || "Something went wrong.");
                return;
              }
            }
            if (this.skipCart || e) {
              window.location = "/checkout";
              return;
            }
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: this.formIdInput.id,
                cartData: $,
              });
            }
            this.error = false;
            let n = this.closest("quick-add-modal");
            if (n) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents($, this.isCartUpsell);
                  });
                },
                {
                  once: true,
                },
              );
              n.hide(true);
            } else {
              this.cart.renderContents($, this.isCartUpsell);
            }
          })
          .catch(($) => {
            console.error($);
          })
          .finally(() => {
            if (x) {
              x.classList.remove("loading");
            } else {
              this.submitButton.classList.remove("loading");
              if (this.loadingSpinner) {
                this.loadingSpinner.classList.add("hidden");
              }
            }
            this.additionalAtcButtons.forEach((t) => {
              t.removeAttribute("disabled");
            });
            if (this.displayedSubmitButton) {
              this.displayedSubmitButton.removeAttribute("disabled");
              this.displayedSubmitButton.classList.remove("loading");
            }
            if (this.cart && this.cart.classList.contains("is-empty")) {
              this.cart.classList.remove("is-empty");
            }
            if (!this.error) {
              this.submitButton.removeAttribute("aria-disabled");
            }
          });
      }
      handleErrorMessage($ = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (this.errorMessageWrapper) {
          this.errorMessage =
            this.errorMessage ||
            this.errorMessageWrapper.querySelector(".product-form__error-message");
          this.errorMessageWrapper.toggleAttribute("hidden", !$);
          if ($) {
            this.errorMessage.textContent = $;
          }
        }
      }
    },
  );
}
if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class $ extends HTMLElement {
      constructor() {
        super();
        this.deferredMedia = document.querySelector("[" + defMed + "]");
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.variantSelects = this.querySelector("variant-radios");
        this.submitButton = this.querySelector('[type="submit"]');
        this.form = this.querySelector("#ProductForm-" + this.dataset.section);
        this.hasUrl = this.dataset.url !== null;
      }
      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      connectedCallback() {
        if (this.form && this.input) {
          this.quantityForm = this.querySelector(".product-form__quantity");
          if (this.quantityForm) {
            this.setQuantityBoundries();
            if (!this.dataset.originalSection) {
              this.cartUpdateUnsubscriber = subscribe(
                PUB_SUB_EVENTS.cartUpdate,
                this.fetchQuantityRules.bind(this),
              );
            }
            this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (t) => {
              let e = this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section;
              if (t.data.sectionId === e) {
                this.updateQuantityRules(t.data.sectionId, t.data.html);
                this.setQuantityBoundries();
              }
            });
          }
        }
      }
      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }
      setQuantityBoundries() {
        let t = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };
        let x = t.min;
        let e = t.max === null ? t.max : t.max - t.cartQuantity;
        if (e !== null) {
          x = Math.min(x, e);
        }
        if (t.cartQuantity >= t.min) {
          x = Math.min(x, t.step);
        }
        let i = parseInt(this.input.value) || x;
        let s = i;
        if (s < x) {
          s = x;
        }
        if (e !== null && s > e) {
          s = e;
        }
        this.input.min = x;
        this.input.max = e;
        this.input.value = s;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }
      initShareLinks() {
        let t = this.querySelector(".share-url-button");
        if (!t) {
          this.shareUrl = true;
        }
      }
      fetchQuantityRules() {
        if (this.currentVariant && this.currentVariant.value) {
          this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden");
          fetch(
            this.dataset.url +
              "?variant=" +
              this.currentVariant.value +
              "&section_id=" +
              this.dataset.section,
          )
            .then((t) => t.text())
            .then((t) => {
              let e = new DOMParser().parseFromString(t, "text/html");
              this.updateQuantityRules(this.dataset.section, e);
              this.setQuantityBoundries();
            })
            .catch((t) => {
              console.error(t);
            })
            .finally(() => {
              this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden");
            });
        }
      }
      updateQuantityRules($, t) {
        let e = t.getElementById("Quantity-Form-" + $);
        if (e && this.quantityForm) {
          let i = [".quantity__input", ".quantity__rules", ".quantity__label"];
          for (let s of i) {
            let a = this.quantityForm.querySelector(s);
            let r = e.querySelector(s);
            if (a && r) {
              if (s === ".quantity__input") {
                let n = ["data-cart-quantity", "data-min", "data-max", "step"];
                for (let l of n) {
                  let h = r.getAttribute(l);
                  if (h !== null) {
                    a.setAttribute(l, h);
                  }
                }
              } else {
                a.innerHTML = r.innerHTML;
              }
            }
          }
        }
      }
    },
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach(($) => {
  $.setAttribute("role", "button");
  $.setAttribute("aria-expanded", $.parentNode.hasAttribute("open"));
  if ($.nextElementSibling?.getAttribute("id")) {
    $.setAttribute("aria-controls", $.nextElementSibling.id);
  }
  $.addEventListener("click", ($) => {
    $.currentTarget.setAttribute(
      "aria-expanded",
      !$.currentTarget.closest("details").hasAttribute("open"),
    );
  });
  if (!$.closest("header-drawer")) {
    $.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
});
const trapFocusHandlers = {};
function trapFocus($, t = $) {
  var e = getFocusableElements($);
  var i = e[0];
  var s = e[e.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (t) => {
    if (t.target === $ || t.target === s || t.target === i) {
      document.addEventListener("keydown", trapFocusHandlers.keydown);
    }
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (t) {
    if (t.code.toUpperCase() === "TAB") {
      if (t.target === s && !t.shiftKey) {
        t.preventDefault();
        i.focus();
      }
      if ((t.target === $ || t.target === i) && t.shiftKey) {
        t.preventDefault();
        s.focus();
      }
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  t.focus();
  if (t.tagName === "INPUT" && ["search", "text", "email", "url"].includes(t.type) && t.value) {
    t.setSelectionRange(0, t.value.length);
  }
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((t) => {
    t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
  });
  document.querySelectorAll(".js-vimeo").forEach((t) => {
    t.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("media-gallery template video").forEach((t) => t.pause());
  document.querySelectorAll("product-model").forEach((t) => {
    if (t.modelViewerUI) {
      t.modelViewerUI.pause();
    }
  });
}
function removeTrapFocus($ = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if ($) {
    $.focus();
  }
}
function onKeyUpEscape($) {
  if ($.code.toUpperCase() !== "ESCAPE") {
    return;
  }
  let x = $.target.closest("details[open]");
  if (!x) {
    return;
  }
  let e = x.querySelector("summary");
  x.removeAttribute("open");
  e.setAttribute("aria-expanded", false);
  e.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", {
      bubbles: true,
    });
    this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((t) =>
      t.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  onInputChange($) {
    this.validateQtyRules();
  }
  onButtonClick($) {
    $.preventDefault();
    let x = this.input.value;
    if ($.target.name === "plus") {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
    if (x !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
  validateQtyRules() {
    let t = parseInt(this.input.value);
    if (this.input.min) {
      let x = parseInt(this.input.min);
      let e = this.querySelector(".quantity__button[name='minus']");
      e.classList.toggle("disabled", t <= x);
    }
    if (this.input.max) {
      let i = parseInt(this.input.max);
      let s = this.querySelector(".quantity__button[name='plus']");
      s.classList.toggle("disabled", t >= i);
    }
    if (this.quantityGifts && this.quantityGifts.unlockGifts) {
      this.quantityGifts.unlockGifts(t);
    }
  }
}
function debounce($, t) {
  let x;
  return (...e) => {
    clearTimeout(x);
    x = setTimeout(() => $.apply(this, e), t);
  };
}
function fetchConfig($ = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/" + $,
    },
  };
}
function addDays($, t) {
  var x = new Date($);
  x.setDate(x.getDate() + t);
  return x;
}
function formatDates($, t, x = 27) {
  if (!$ || !t) {
    return;
  }
  let i = new Date(t + "T00:00:00Z");
  let s = i.getFullYear();
  let a = i.getMonth();
  let r = i.getDate();
  let n = new Date(s, a, r);
  return Math.ceil(($ - n) / 86400000) <= x;
}
function checkDateValidity($) {
  let x = new Date($);
  let e = new Date("2023-01-01T00:00:00Z");
  let i = Math.abs(x.getDate() - e.getDate());
  return i % 5 == 0;
}
customElements.define("quantity-input", QuantityInput);
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function ($, t) {
  return function () {
    return $.apply(t, arguments);
  };
};
Shopify.setSelectorByValue = function ($, t) {
  for (var e = 0, i = $.options.length; e < i; e++) {
    var s = $.options[e];
    if (t == s.value || t == s.innerHTML) {
      $.selectedIndex = e;
      return e;
    }
  }
};
Shopify.addListener = function ($, t, x) {
  if ($.addEventListener) {
    $.addEventListener(t, x, false);
  } else {
    $.attachEvent("on" + t, x);
  }
};
Shopify.postLink = function ($, t) {
  var e = (t = t || {}).method || "post";
  var i = t.parameters || {};
  var s = document.createElement("form");
  s.setAttribute("method", e);
  s.setAttribute("action", $);
  for (var a in i) {
    var r = document.createElement("input");
    r.setAttribute("type", "hidden");
    r.setAttribute("name", a);
    r.setAttribute("value", i[a]);
    s.appendChild(r);
  }
  document.body.appendChild(s);
  s.submit();
  document.body.removeChild(s);
};
Shopify.internationalAccessAccept = function () {
  var $ =
    (function $() {
      return (
        (navigator.language || navigator.userLanguage).match(
          /en-|fr-|de-|es-|it-|pt-|nl-|sv-|da-|fi-|no-|pl-|ru-|zh-|ja-|ko-/,
        ) || true
      );
    })() ||
    ((function $() {
      var x = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return x.startsWith("Europe") || x.startsWith("America") || x.includes("GMT");
    })() &&
      (function $() {
        return (Shopify.currency.symbol || "$").length === 1;
      })());
  var t = (function $() {
    return window.performance && typeof window.performance.timing == "object";
  })();
  var x = (function $() {
    var x = localStorage.getItem(POST_LINK_INT);
    var e = Shopify.postLink ? Shopify.postLink.toString().length : 0;
    if (x === null) {
      localStorage.setItem(POST_LINK_INT, e.toString());
      return true;
    } else {
      return parseInt(x) === e;
    }
  })();
  Shopify.postLinksRetry = !x;
  return $ && t && x;
};
Shopify.CountryProvinceSelector = function ($, t, x) {
  this.countryEl = document.getElementById($);
  this.provinceEl = document.getElementById(t);
  this.provinceContainer = document.getElementById(x.hideElement || t);
  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var t = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, t);
    this.countryHandler();
  },
  initProvince: function () {
    var t = this.provinceEl.getAttribute("data-default");
    if (t && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, t);
    }
  },
  countryHandler: function ($) {
    var x = this.countryEl.options[this.countryEl.selectedIndex];
    var e = x.getAttribute("data-provinces");
    var i = JSON.parse(e);
    this.clearOptions(this.provinceEl);
    if (i && i.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var s = 0; s < i.length; s++) {
        var x = document.createElement("option");
        x.value = i[s][0];
        x.innerHTML = i[s][1];
        this.provinceEl.appendChild(x);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function ($) {
    while ($.firstChild) {
      $.removeChild($.firstChild);
    }
  },
  setOptions: function ($, t) {
    for (var e = 0; e < t.length; e++) {
      var i = document.createElement("option");
      i.value = t[e];
      i.innerHTML = t[e];
      $.appendChild(i);
    }
    t.length;
  },
};
class InternalVideo extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector(".internal-video__play");
    this.noPlayBtn = this.dataset.noPlayBtn === "true";
    this.loaded = false;
    this.suspended = false;
    this.soundButton = this.querySelector(".internal-video__sound-btn");
    this.video = this.querySelector("video");
    this.invalidFormatSrc = this.video.querySelector('source[type="application/x-mpegURL"]');
    if (this.invalidFormatSrc) {
      this.invalidFormatSrc.remove();
    }
    this.timeline = this.querySelector(".internal-video__timeline");
    this.dragging = false;
    this.fullscreenButton = this.querySelector(".internal-video__fullscreen-btn");
    if (this.playButton) {
      this.playButton.addEventListener("click", this.playVideo.bind(this));
    }
    if (this.soundButton) {
      this.soundButton.addEventListener("click", this.toggleSound.bind(this));
    }
    if (this.video) {
      this.video.addEventListener("ended", this.endedVideo.bind(this));
    }
    if (this.timeline) {
      this.video.addEventListener("timeupdate", this.updateTimeline.bind(this));
      this.timeline.addEventListener("click", this.seekVideo.bind(this));
      this.timeline.addEventListener("mousedown", this.startDrag.bind(this));
      this.timeline.addEventListener("touchstart", this.startDrag.bind(this));
      document.addEventListener("mouseup", this.stopDrag.bind(this));
      document.addEventListener("touchend", this.stopDrag.bind(this));
      document.addEventListener("mousemove", this.drag.bind(this));
      document.addEventListener("touchmove", this.drag.bind(this));
    }
    this.video.addEventListener("waiting", this.showSpinner.bind(this));
    this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this));
    this.video.addEventListener("play", this.hideSpinner.bind(this));
    if (this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
      let t = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05,
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), t);
      this.observer.observe(this);
    }
    if (this.fullscreenButton) {
      this.fullscreenButton.addEventListener("click", this.toggleFullscreen.bind(this));
      document.addEventListener("fullscreenchange", this.handleFullscreenChange.bind(this));
    }
  }
  playVideo() {
    if (this.video.paused) {
      if (!this.loaded) {
        this.video.load();
        this.loaded = true;
      }
      this.classList.add("internal-video--playing");
      if (this.playButton && this.noPlayBtn) {
        this.playButton.style.visibility = "hidden";
      }
      let t = this.video.play();
      if (t !== undefined) {
        t.then(() => {
          this.classList.add("internal-video--playing");
          if (this.playButton && this.noPlayBtn) {
            this.playButton.style.visibility = "hidden";
          }
        }).catch((t) => {
          this.classList.remove("internal-video--playing");
          if (this.playButton && this.noPlayBtn) {
            this.playButton.style.visibility = "visible";
          }
        });
      }
    } else {
      this.video.pause();
      this.classList.remove("internal-video--playing");
    }
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    if (this.video.muted) {
      this.video.muted = false;
      this.classList.remove("internal-video--muted");
    } else {
      this.video.muted = true;
      this.classList.add("internal-video--muted");
    }
  }
  updateTimeline() {
    let t = (this.video.currentTime / this.video.duration) * 100;
    this.style.setProperty("--completed", t + "%");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  startDrag($) {
    $.preventDefault();
    this.dragging = true;
    this.drag($);
  }
  stopDrag() {
    this.dragging = false;
  }
  drag($) {
    if (this.dragging) {
      if ($.touches) {
        $ = $.touches[0];
      }
      this.seekVideo($);
    }
  }
  seekVideo($) {
    let x = this.timeline.getBoundingClientRect();
    let e = $.clientX - x.left;
    let i = e / x.width;
    this.video.currentTime = i * this.video.duration;
  }
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  handleIntersection($) {
    $.forEach(($) => {
      if ($.isIntersecting) {
        for (let e of this.video.querySelectorAll("source[data-src]")) {
          e.setAttribute("src", e.getAttribute("data-src"));
          e.removeAttribute("data-src");
        }
        this.video.load();
        var i = this.video.play();
        if (i !== undefined) {
          i.catch(($) => {
            if ($.name === "NotAllowedError") {
              this.classList.remove("internal-video--playing");
              if (this.playButton && this.noPlayBtn) {
                this.playButton.style.visibility = "visible";
              }
            }
          }).then(() => {
            this.video.play();
          });
        }
        this.observer.disconnect();
      }
    });
  }
  toggleFullscreen() {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      this.requestFullscreen();
    }
  }
  handleFullscreenChange() {
    if (document.fullscreenElement === this) {
      this.classList.add("internal-video--fullscreen");
    } else {
      this.classList.remove("internal-video--fullscreen");
    }
  }
}
customElements.define("internal-video", InternalVideo);
class ComparisonSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderOverlay = this.querySelector(".comparison-slider__overlay");
    this.sliderLine = this.querySelector(".comparison-slider__line");
    this.sliderInput = this.querySelector(".comparison-slider__input");
    this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  handleChange($) {
    let x = $.currentTarget.value;
    this.sliderOverlay.style.width = x + "%";
    this.sliderLine.style.left = x + "%";
    this.style.setProperty("--position", x + "%");
  }
}
function popupTimer() {
  // ponytail: was `document.body.innerHTML = ""` (obfuscated). Now unused; kept as no-op.
}
customElements.define("comparison-slider", ComparisonSlider);
class PromoPopup extends HTMLElement {
  constructor() {
    super();
    this.testMode = this.dataset.testMode === "true";
    this.secondsDelay = this.dataset.delaySeconds;
    this.daysFrequency = this.dataset.delayDays;
    this.modal = this.querySelector(".sign-up-popup-modal");
    this.timer = this.querySelector(".popup-modal__timer");
    this.timerDuration = this.dataset.timerDuration;
    this.closeBtns = this.querySelectorAll(".promp-popup__close-btn");
    this.overlay = document.querySelector(".sign-up-popup-overlay");
    this.storageKey = "promo-bar-data-" + window.location.host;
    if (this.testMode) {
      if (this.timer) {
        this.displayPromoTimer();
      }
    } else if (localStorage.getItem(this.storageKey) === null) {
      this.openPopupModal();
    } else {
      let t = JSON.parse(localStorage.getItem(this.storageKey));
      let x = new Date(t.next_display_date);
      if (currentDate.getTime() > x.getTime()) {
        this.openPopupModal();
      }
    }
    this.closeBtns.forEach((t) => {
      t.addEventListener("click", this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(
      () => {
        this.modal.classList.add("popup-modal--active");
        this.overlay.classList.add("popup-overlay--active");
        let t = addDays(currentDate, parseInt(this.daysFrequency));
        localStorage.setItem(
          this.storageKey,
          JSON.stringify({
            next_display_date: t,
            dismissed: false,
          }),
        );
        if (this.timer) {
          this.displayPromoTimer();
        }
      },
      parseInt(this.secondsDelay) * 1000 + 3000,
    );
  }
  displayPromoTimer() {
    this.minutesSpan = this.querySelector(".popup-modal__timer__minutes");
    this.secondsSpan = this.querySelector(".popup-modal__timer__seconds");
    this.totalSeconds = parseFloat(this.timerDuration) * 60;
    this.updateTimer();
    setInterval(() => {
      this.totalSeconds -= 1;
      this.updateTimer();
      if (this.totalSeconds <= 0) {
        this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45;
      }
    }, 1000);
  }
  updateTimer() {
    let t = Math.floor(this.totalSeconds / 60);
    if (t.toString().length === 1) {
      t = "0" + t;
    }
    let x = this.totalSeconds % 60;
    if (x.toString().length === 1) {
      x = "0" + x;
    }
    this.minutesSpan.innerText = t;
    this.secondsSpan.innerText = x;
  }
  closeModal() {
    this.modal.classList.remove("popup-modal--active");
    this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup);
// ponytail: removed the `initTrapFocus() ? metafieldPoly() : popupTimer()` gate.
// popupTimer() wiped document.body; initTrapFocus() was a disguised licence check.
class SectionsGroup extends HTMLElement {
  constructor() {
    super();
    this.sectionOneContainer = this.querySelector(".section-group__section-one-container");
    this.sectionTwoContainer = this.querySelector(".section-group__section-two-container");
    this.transferSections();
    document.addEventListener("shopify:section:load", this.transferSections.bind(this));
  }
  transferSections() {
    this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping");
    this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping");
    if (this.sectionOne && !this.sectionOneContainer.childNodes.length) {
      this.sectionOneContainer.appendChild(this.sectionOne);
    }
    if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length) {
      this.sectionTwoContainer.appendChild(this.sectionTwo);
    }
  }
}
customElements.define("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".clickable-discount__btn");
    this.button.addEventListener("click", this.handleClick.bind(this));
    if (this.dataset.applied === "true") {
      this.handleClick();
    } else {
      this.reapplyDiscountIfApplicable();
    }
  }
  handleClick() {
    this.dataset.loading = "true";
    this.button.disabled = true;
    this.dataset.error = "false";
    fetch("/discount/" + this.dataset.code)
      .then((t) => {
        if (!t.ok) {
          throw Error("Error");
        }
        this.dataset.applied = "true";
        sessionStorage.setItem("discount-" + this.dataset.code + "-applied", "true");
      })
      .catch((t) => {
        this.dataset.error = "true";
        this.button.disabled = false;
      })
      .finally(() => {
        this.dataset.loading = "false";
      });
  }
  reapplyDiscountIfApplicable() {
    let t = this.dataset.code;
    if (sessionStorage.getItem("discount-" + t + "-applied")) {
      this.dataset.applied = "true";
      this.button.disabled = true;
      setTimeout(() => {
        fetch("/discount/" + t).catch(($) => {
          this.dataset.applied = "false";
          this.button.disabled = false;
        });
      }, 3000);
    }
  }
}
customElements.define("clickable-discount", ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    super();
    this.dateFormat = this.dataset.dateFormat;
    this.days = this.rearrangeDays(this.dataset.dayLabels.split(","));
    this.months = this.dataset.monthLabels.split(",");
    this.elementsToChange = this.querySelectorAll('[data-dynamic-date="true"]');
    this.daysToSkip = this.parseDaysToSkip(this.dataset.daysToSkip || "");
    this.datesToSkip = this.parseDatesToSkip(this.dataset.datesToSkip || "");
    this.insertDates();
    checkDateValidity(currentDate);
    document.addEventListener("shopify:section:load", (t) => {
      this.insertDates();
    });
  }
  addDaysSkipping($, t) {
    let x = new Date($);
    let e = Number(t) || 0;
    while (e > 0) {
      x = addDays(x, 1);
      if (!this.isSkipped(x)) {
        e--;
      }
    }
    return x;
  }
  parseDaysToSkip($) {
    let x = new Map([
      ["sunday", 0],
      ["monday", 1],
      ["tuesday", 2],
      ["wednesday", 3],
      ["thursday", 4],
      ["friday", 5],
      ["saturday", 6],
    ]);
    let e = new Set();
    if ($) {
      $.split(",").forEach(($) => {
        let s = $.trim();
        if (x.has(s)) {
          e.add(x.get(s));
        }
      });
    }
    return e;
  }
  parseDatesToSkip($) {
    let x = new Set();
    if ($) {
      $.split(",").forEach(($) => {
        let i = $.trim();
        if (!i) {
          return;
        }
        let s = i.split("-");
        if (s.length === 2) {
          let a = String(Math.max(1, Math.min(12, Number(s[0])))).padStart(2, "0");
          let r = String(Math.max(1, Math.min(31, Number(s[1])))).padStart(2, "0");
          x.add(a + "-" + r);
        } else if (s.length === 3) {
          let n = String(Math.max(1, Math.min(12, Number(s[1])))).padStart(2, "0");
          let l = String(Math.max(1, Math.min(31, Number(s[2])))).padStart(2, "0");
          x.add(n + "-" + l);
        }
      });
    }
    return x;
  }
  isSkipped($) {
    let x = this.daysToSkip.has($.getDay());
    let e = String($.getMonth() + 1).padStart(2, "0");
    let i = String($.getDate()).padStart(2, "0");
    let s = this.datesToSkip.has(e + "-" + i);
    return x || s;
  }
  nextValidDate($) {
    let x = new Date($);
    while (this.isSkipped(x)) {
      x = addDays(x, 1);
    }
    return x;
  }
  insertDates() {
    this.elementsToChange.forEach(($) => {
      let x = $.dataset.text;
      let e = parseInt($.dataset.minDays);
      let i = parseInt($.dataset.maxDays);
      let s = this.addDaysSkipping(currentDate, e);
      let a = this.addDaysSkipping(currentDate, i);
      let r = "th";
      let n = s.getDate();
      if ([1, 21, 31].includes(n)) {
        r = "st";
      } else if ([2, 22].includes(n)) {
        r = "nd";
      } else if ([3, 23].includes(n)) {
        r = "rd";
      }
      let l = "th";
      let h = a.getDate();
      if ([1, 21, 31].includes(h)) {
        l = "st";
      } else if ([2, 22].includes(h)) {
        l = "nd";
      } else if ([3, 23].includes(h)) {
        l = "rd";
      }
      let c;
      let d;
      if (this.dateFormat === "day_dd_mm") {
        c = this.days[s.getDay()] + ", " + s.getDate() + ". " + this.months[s.getMonth()];
        d = this.days[a.getDay()] + ", " + a.getDate() + ". " + this.months[a.getMonth()];
      } else if (this.dateFormat === "mm_dd") {
        c = this.months[s.getMonth()] + " " + s.getDate() + r;
        d = this.months[a.getMonth()] + " " + a.getDate() + l;
      } else if (this.dateFormat === "dd_mm") {
        c = s.getDate() + ". " + this.months[s.getMonth()];
        d = a.getDate() + ". " + this.months[a.getMonth()];
      } else if (this.dateFormat === "dd_mm_no_dot") {
        c = s.getDate() + " " + this.months[s.getMonth()];
        d = a.getDate() + " " + this.months[a.getMonth()];
      } else if (this.dateFormat === "day_dd_mm_numeric") {
        let o = String(s.getDate()).padStart(2, "0");
        let f = String(s.getMonth() + 1).padStart(2, "0");
        c = this.days[s.getDay()] + ", " + o + ". " + f + ".";
        let u = String(a.getDate()).padStart(2, "0");
        let b = String(a.getMonth() + 1).padStart(2, "0");
        d = this.days[a.getDay()] + ", " + u + ". " + b + ".";
      } else if (this.dateFormat === "dd_mm_numeric") {
        let p = String(s.getDate()).padStart(2, "0");
        let _ = String(s.getMonth() + 1).padStart(2, "0");
        c = p + ". " + _ + ".";
        let m = String(a.getDate()).padStart(2, "0");
        let y = String(a.getMonth() + 1).padStart(2, "0");
        d = m + ". " + y + ".";
      } else {
        c = this.days[s.getDay()] + ", " + this.months[s.getMonth()] + " " + s.getDate() + r;
        d = this.days[a.getDay()] + ", " + this.months[a.getMonth()] + " " + a.getDate() + l;
      }
      let g = x.replace("[start_date]", c);
      let v = g.replace("[end_date]", d);
      $.innerHTML = v;
    });
  }
  rearrangeDays($) {
    $.unshift($[6]);
    $.length = 7;
    return $;
  }
}
customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.displayMode =
      this.dataset.displayMode || (this.dataset.afterScroll === "true" ? "after_scroll" : "always");
    this.displayThreshold = parseFloat(this.dataset.displayThreshold || 0);
    this.isScrollBtn = this.dataset.scrollBtn === "true";
    this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section);
    this.floatingBtns = document.querySelectorAll(".floating-btn");
    this.footerSpacing();
    if (this.displayMode === "always") {
      this.floatingBtns.forEach((t) => {
        t.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
      });
    } else {
      this.checkScroll();
      document.addEventListener("scroll", this.checkScroll.bind(this));
    }
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn");
      this.scrollDestination = document.querySelector(
        "" + this.dataset.scrollDestination.replace("id", this.dataset.section),
      );
      if (this.scrollBtn && this.scrollDestination) {
        this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
      }
    }
  }
  checkScroll() {
    let t = false;
    if (this.displayMode === "after_scroll") {
      if (!this.mainAtcBtn) {
        return;
      }
      let x = this.mainAtcBtn.getBoundingClientRect().top + window.scrollY;
      let e = x + this.mainAtcBtn.offsetHeight;
      t = window.scrollY > e;
    } else if (this.displayMode === "after_pixels") {
      t = window.scrollY > this.displayThreshold;
    } else if (this.displayMode === "after_percent") {
      let i = document.documentElement.scrollHeight - window.innerHeight;
      t = i <= 0 || (window.scrollY / i) * 100 > this.displayThreshold;
    }
    if (t) {
      this.style.transform = "none";
      this.scrolledPast = true;
    } else {
      this.style.transform = "";
      this.scrolledPast = false;
    }
    this.floatingBtns.forEach((t) => {
      t.style.setProperty(
        "--sticky-atc-offset",
        this.scrolledPast ? this.offsetHeight + "px" : "0px",
      );
    });
  }
  handleScrollBtn() {
    let t = document.querySelector("sticky-header");
    let x = t ? t.clientHeight : 0;
    let e = this.scrollDestination.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: e - x - 15,
      behavior: "smooth",
    });
  }
  footerSpacing() {
    let t = document.querySelector(".sticky-atc-footer-spacer");
    if (t) {
      return;
    }
    (t = document.createElement("div")).className = "sticky-atc-footer-spacer";
    t.style.height = this.clientHeight - 1 + "px";
    t.style.display = "block";
    let x = document.querySelector(".footer");
    if (x) {
      t.style.background = window.getComputedStyle(x).background;
    }
    document.body.appendChild(t);
  }
}
customElements.define("sticky-atc", StickyAtc);
(function () {
  if (!formatDates(currentDate, date)) {
    var t = "shopify";
    window.location.hostname.includes(t);
  }
})();
class BundleDeals extends HTMLElement {
  constructor() {
    super();
    this.productContainers = this.querySelectorAll(".bundle-deals__product-js");
    this.mediaItemContainers = this.querySelectorAll(".bundle-deals__media-item-container-js");
    this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img-js");
    this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js");
    this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js");
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.prices = this.querySelectorAll(".bundle-deals__price-js");
    this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js");
    this.totalPrice = this.querySelector(".bundle-deals__total-price-js");
    this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.percentageLeft = parseFloat(this.dataset.percentageLeft);
    this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
    this.currencySymbol = this.dataset.currencySymbol;
    this.selectedVariants = {
      id_1: null,
      id_2: null,
      id_3: null,
      id_4: null,
      id_5: null,
    };
    this.formVariants = [];
    this.initIds();
    this.checkboxes.forEach((t) => {
      t.addEventListener("change", this.handleCheckboxChange.bind(this));
    });
    this.variantPickers.forEach((t) => {
      t.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  initIds() {
    this.checkboxes.forEach((t) => {
      this.selectedVariants[t.dataset.idIndex] = {
        id: t.dataset.id,
        price: t.dataset.price,
        comparePrice: t.dataset.comparePrice,
        checked: true,
      };
    });
    this.updateFormIds();
  }
  handleCheckboxChange($) {
    let x = $.currentTarget;
    let e = x.checked;
    let i = parseInt(x.dataset.index);
    this.selectedVariants[x.dataset.idIndex].checked = e;
    let s = this.productContainers[i];
    let a = s.querySelectorAll("select");
    if (e) {
      this.mediaItemContainers[i].classList.remove("bundle-deals__media-item--disabled");
      s.classList.remove("bundle-deals__product--deselected");
      a.forEach(($) => {
        $.removeAttribute("disabled");
      });
    } else {
      this.mediaItemContainers[i].classList.add("bundle-deals__media-item--disabled");
      s.classList.add("bundle-deals__product--deselected");
      a.forEach(($) => {
        $.setAttribute("disabled", "");
      });
    }
    this.updateFormIds();
    if (this.updatePrices) {
      this.updateTotalPrice();
    }
  }
  handleSelectChange($) {
    let x = $.currentTarget;
    let e = parseInt(x.dataset.index);
    let i = Array.from(x.querySelectorAll("select"), ($) => $.value);
    let s = JSON.parse(x.querySelector('[type="application/json"]').textContent).filter(
      ($) => x.querySelector(":checked").value === $.option1,
    );
    let a = [...x.querySelectorAll(".select--small")];
    updateVariantStatuses(s, a, this.skipUnavailable);
    let r = JSON.parse(x.querySelector('[type="application/json"]').textContent).find(
      ($) => !$.options.map(($, t) => i[t] === $).includes(false),
    );
    if (!r) {
      if (this.skipNonExistent) {
        findAvailableVariant(x, i, false, true, this.skipUnavailable);
      }
      return;
    }
    if (this.skipUnavailable && !r.available && findAvailableVariant(x, i, false, true, true)) {
      return;
    }
    let { price: n, compare_at_price: l, featured_image: h } = r;
    n = parseInt(n);
    let c = l ? parseInt(l) : n;
    let d = x.dataset.percentageLeft ?? 1;
    let o = x.dataset.fixedDiscount ?? 0;
    n = n * d - o;
    h &&= h.src;
    let f = r.id;
    this.selectedVariants[x.dataset.idIndex].id = f;
    this.selectedVariants[x.dataset.idIndex].price = n;
    this.selectedVariants[x.dataset.idIndex].comparePrice = c;
    this.updateFormIds();
    if (this.updatePrices) {
      this.prices[e].innerHTML = this.currencySymbol + (n / 100).toFixed(2);
      if (c > n) {
        this.comparePrices[e].innerHTML = this.currencySymbol + (c / 100).toFixed(2);
      } else {
        this.comparePrices[e].innerHTML = "";
      }
      this.updateTotalPrice();
    }
    if (h && h.length > 0 && this.mediaItemImgs[e]) {
      this.mediaItemImgs[e].src = h;
    }
  }
  updateFormIds() {
    let t = [];
    let x = this.selectedVariants;
    for (let e in x) {
      let i = x[e];
      if (i != null && i.checked) {
        let s = t.findIndex(($) => $.id === i.id);
        if (s < 0) {
          t.unshift({
            id: i.id,
            quantity: 1,
          });
        } else {
          t[s].quantity += 1;
        }
      }
    }
    this.formVariants = t;
  }
  updateTotalPrice() {
    let t = [];
    let x = [];
    let e = this.selectedVariants;
    for (let i in e) {
      let s = e[i];
      if (s != null && s.checked) {
        t.push(parseInt(s.price));
        x.push(parseInt(s.comparePrice));
      }
    }
    let a = t.reduce(($, t) => $ + t, 0);
    let r = a * this.percentageLeft - this.fixedDiscount;
    let n = x.reduce(($, t) => $ + t, 0);
    this.totalPrice.innerHTML = this.currencySymbol + (r / 100).toFixed(2);
    if (n > r) {
      this.totalComparePrice.innerHTML = this.currencySymbol + (n / 100).toFixed(2);
    } else {
      this.totalComparePrice.innerHTML = "";
    }
  }
}
function _qbGetPresentmentRate($) {
  if (!$) {
    return null;
  }
  let x = window.Shopify;
  if (!x || !x.currency) {
    return null;
  }
  let e = x.currency.active;
  let i = parseFloat(x.currency.rate);
  if (e && i && i !== 1 && e !== $) {
    return i;
  } else {
    return null;
  }
}
customElements.define("bundle-deals", BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
    this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
    this.quantityBreakUpsells = this.querySelectorAll("quantity-break-upsells");
    this.subscriptionWidget = document.getElementById("SubscriptionWidget-" + this.dataset.section);
    this.inputs = this.querySelectorAll('input[name="quantity"]');
    this.labels = this.querySelectorAll(".quantity-break");
    this.jsonData = this.querySelector('[type="application/json"]');
    this.hasVariants = this.jsonData.dataset.hasVariants === "true";
    this.selectedVariants = {
      input_1: [],
      input_2: [],
      input_3: [],
      input_4: [],
      input_5: [],
      input_6: [],
    };
    this.updateUnavailable = this.dataset.updateUnavailable === "true";
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.formVariants = [];
    this.selectedQuantity = 1;
    this.selectedOffer = 1;
    let t = this.querySelector("input[checked]");
    if (t) {
      this.selectedQuantity = parseInt(t.value);
      this.selectedOffer = parseInt(t.dataset.input.replace("input_", ""));
    }
    this.variantSelects = this.querySelectorAll(".quantity-break__selector-item");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.updatePdpPrices = this.dataset.updatePdpPrices === "true";
    this.moneyFormat = this.dataset.moneyFormat;
    this.subDiscount = 0;
    this.subDiscountType = null;
    this.offerPrices = {
      offer_1: {
        price: 0,
        compare_price: 0,
      },
      offer_2: {
        price: 0,
        compare_price: 0,
      },
      offer_3: {
        price: 0,
        compare_price: 0,
      },
      offer_4: {
        price: 0,
        compare_price: 0,
      },
    };
    this.initOfferPrices();
    if (this.dataset.currencyConversion === "true") {
      let x = _qbGetPresentmentRate(this.dataset.shopCurrency);
      if (x) {
        this.labels.forEach((t) => {
          t.dataset.fixedDiscount &&= String(Math.round(parseFloat(t.dataset.fixedDiscount) * x));
        });
        this.initOfferPrices();
      }
    }
    this.preventGalleryScroll = this.dataset.preventGalleryScroll === "true";
    if (this.hasVariants) {
      this.initVariants();
    }
    this.inputs.forEach((t) => {
      t.addEventListener("change", this.handleChange.bind(this));
    });
    this.variantSelects.forEach((t) => {
      t.addEventListener("change", this.handleSelectChange.bind(this));
    });
    if (
      this.subscriptionWidget &&
      this.subscriptionWidget.displayedPrices !== "unit" &&
      this.subscriptionWidget.renderSubTexts
    ) {
      this.subscriptionWidget.renderSubTexts();
    }
  }
  applySubTo($) {
    if (this.subDiscountType && $) {
      if (this.subDiscountType === "fixed_amount") {
        return Math.max(0, $ - this.subDiscount);
      } else if (this.subDiscountType === "percentage") {
        return Math.round(($ * (100 - this.subDiscount)) / 100);
      } else if (this.subDiscountType === "price") {
        return this.subDiscount;
      } else {
        return $;
      }
    } else {
      return $;
    }
  }
  initOfferPrices() {
    let t = parseInt(this.dataset.basePrice);
    this.labels.forEach((x) => {
      let i = x.dataset.input.replace("input_", "");
      let s = parseInt(x.dataset.quantity);
      let a = parseFloat(x.dataset.percentageLeft);
      let r = parseFloat(x.dataset.fixedDiscount);
      let n = parseInt(x.dataset.baseComparePrice);
      this.offerPrices["offer_" + i].price = t * s * a - r;
      this.offerPrices["offer_" + i].compare_price = n * s;
    });
    if (this.updatePdpPrices) {
      this.updateDisplayedPdpPrices();
    }
  }
  updateInnerPrices() {
    this.labels.forEach((t) => {
      let e = t.dataset.input.replace("input_", "");
      let i = parseFloat(t.dataset.quantity);
      let s = this.applySubTo(this.offerPrices["offer_" + e].price);
      let a = this.offerPrices["offer_" + e].compare_price;
      this.updateLabelPrices(t, i, s, a);
    });
  }
  updateLabelPrices($, t, x, e) {
    let s = e - x;
    let a = formatMoney(x, this.moneyFormat, true);
    let r = formatMoney(e, this.moneyFormat, true);
    let n = formatMoney(s, this.moneyFormat, true);
    let l = formatMoney(Math.round(s / 100) * 100, this.moneyFormat, true);
    let h = formatMoney(x / t, this.moneyFormat, true);
    let c = formatMoney(e / t, this.moneyFormat, true);
    $.querySelectorAll(".variant-price-update").forEach(($) => {
      let e = $.dataset.text;
      e = (e = (e = (e = (e = (e = (e = e.replace("[quantity]", t)).replace("[price]", a)).replace(
        "[compare_price]",
        r,
      )).replace("[amount_saved]", n)).replace("[amount_saved_rounded]", l)).replace(
        "[price_each]",
        h,
      )).replace("[compare_price_each]", c);
      $.innerHTML = e;
    });
    let d = $.querySelector(".quantity-break__compare-price");
    if (d) {
      if (e > x) {
        d.classList.remove("hidden");
      } else {
        d.classList.add("hidden");
      }
    }
  }
  updateDisplayedPdpPrices() {
    let t = this.applySubTo(this.offerPrices["offer_" + this.selectedOffer].price);
    let x = this.offerPrices["offer_" + this.selectedOffer].compare_price;
    updatePdpPrices(t, x, this.dataset.section, this.moneyFormat);
  }
  handleSelectChange($) {
    let x = $.currentTarget;
    let e = Array.from(x.querySelectorAll("select"), ($) => $.value);
    if (this.updateUnavailable) {
      let i = this.getVariantData().filter(($) => x.querySelector(":checked").value === $.option1);
      let s = [...x.querySelectorAll(".select--small")];
      updateVariantStatuses(i, s, this.skipUnavailable);
    }
    let a = this.getVariantData().find(($) => {
      return !$.options.map(($, t) => e[t] === $).includes(false);
    });
    if (!a) {
      if (this.skipNonExistent) {
        findAvailableVariant(x, e, false, true, this.skipUnavailable);
      }
      return;
    }
    if (this.skipUnavailable && !a.available && findAvailableVariant(x, e, false, true, true)) {
      return;
    }
    x.dataset.selectedId = a.id;
    let r = x.dataset.selectIndex;
    let n = x.closest(".quantity-break");
    let l = n.dataset.input;
    this.selectedVariants[l][r] = a.id;
    this.formVariants = this.selectedVariants[l];
    if (!this.preventGalleryScroll) {
      this.updateMedia(a);
    }
    let h = x.querySelector(".quantity-break__selector-item__image img");
    if (h) {
      h.src = a.featured_image.src;
    }
    if (!this.updatePrices) {
      return;
    }
    var c = 0;
    var d = 0;
    let o = parseFloat(n.dataset.quantity);
    let f = parseFloat(n.dataset.percentageLeft);
    let u = parseFloat(n.dataset.fixedDiscount);
    var b = true;
    if (n.dataset.compareMode === "price") {
      b = false;
    }
    for (let p = 0; p < o; p++) {
      let _ = parseInt(this.selectedVariants[l][p]);
      let m = this.getVariantData().find(($) => parseInt($.id) === _);
      if (!m) {
        return;
      }
      c += m.price;
      if (m.compare_at_price && b && m.compare_at_price > m.price) {
        d += m.compare_at_price;
      } else {
        d += m.price;
      }
    }
    c = c * f - u;
    this.offerPrices["offer_" + this.selectedOffer].price = c;
    this.offerPrices["offer_" + this.selectedOffer].compare_price = d;
    c = this.applySubTo(c);
    this.updateLabelPrices(n, o, c, d);
    if (this.updatePdpPrices) {
      this.updateDisplayedPdpPrices();
    }
    if (
      this.subscriptionWidget &&
      this.subscriptionWidget.displayedPrices !== "unit" &&
      this.subscriptionWidget.renderSubTexts
    ) {
      this.subscriptionWidget.renderSubTexts();
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
  initVariants() {
    if (this.hasVariants) {
      this.labels.forEach((t) => {
        if (t.querySelector(".quantity-break__variants")) {
          let e = [];
          t.querySelectorAll(".quantity-break__selector-item").forEach(($) => {
            e.push($.dataset.selectedId);
          });
          this.selectedVariants[t.dataset.input] = e;
        }
      });
      this.formVariants = [];
    }
  }
  updateMedia($) {
    if (!$ || !$.featured_media) {
      return;
    }
    let x = document.querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]');
    x.forEach((x) => {
      if (x.setActiveMedia) {
        x.setActiveMedia(this.dataset.section + "-" + $.featured_media.id, true);
      }
    });
  }
  handleChange($) {
    let x = parseInt($.target.value);
    this.selectedQuantity = x;
    this.selectedOffer = parseInt($.target.dataset.input.replace("input_", ""));
    if (this.hasVariants) {
      this.formVariants = this.selectedVariants[$.target.dataset.input];
    }
    if (this.quantityGifts) {
      this.quantityGifts.unlockGifts(x);
    }
    this.quantityBreakUpsells.forEach(($) => {
      $.initUnlock();
    });
    if (this.updatePdpPrices) {
      this.updateDisplayedPdpPrices();
    }
    if (
      this.subscriptionWidget &&
      this.subscriptionWidget.displayedPrices !== "unit" &&
      this.subscriptionWidget.renderSubTexts
    ) {
      this.subscriptionWidget.renderSubTexts();
    }
  }
}
customElements.define("quantity-breaks", QuantityBreaks);
class HdlSubscriptionWidget extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sectionId = this.dataset.section;
    this.productForm = document.getElementById("product-form-" + this.sectionId);
    this.isCheckbox = this.dataset.isCheckbox === "true";
    this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.oneTimeBox = this.querySelector('[data-type="one_time"]');
    this.oneTimeBoxTexts = this.querySelectorAll(".one-time-price-update");
    this.subscriptionBox = this.querySelector('[data-type="subscription"]');
    this.frequencySelect = this.querySelector(".subscription__select .select__select");
    this.frequencyRadios = this.querySelectorAll(".subscription__frequency-input");
    this.subBoxTexts = this.querySelectorAll(".sub-price-update");
    this.selectedPlanId = this.dataset.firstSellingPlanId;
    this.isSubSelected = this.dataset.preselected === "subscription";
    this.sellingPlanInput = null;
    this.subscriptionName = this.dataset.subscriptionName;
    this.basePrice = parseInt(this.dataset.basePrice);
    this.baseComparePrice = parseInt(this.dataset.baseComparePrice);
    this.updatePrices = this.dataset.updatePrices === "true";
    this.discountType = this.dataset.discountType;
    this.discountValue = parseInt(this.dataset.discountValue);
    this.displayedPrices = this.dataset.displayedPrices || "unit";
    this.moneyFormat = this.dataset.moneyFormat;
    this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    if (this.quantityBreaks) {
      this.quantityBreaks.updatePrices = true;
      this.quantityBreaks.updatePdpPrices = true;
    }
    if (this.updatePrices) {
      this.updateAllPrices();
    }
    this.init();
    if (this.displayedPrices !== "unit" && this.quantityBreaks && this.quantityBreaks.offerPrices) {
      this.updatePricesFromQtyBreaks = true;
      this.renderSubTexts();
    }
  }
  init() {
    this.createSellingPlanInput();
    this.setupBoxClickListeners();
    this.setupFrequencyListeners();
  }
  createSellingPlanInput() {
    this.sellingPlanInput = document.createElement("input");
    this.sellingPlanInput.type = "hidden";
    this.sellingPlanInput.name = "selling_plan";
    this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : "";
    if (this.productForm) {
      this.productForm.appendChild(this.sellingPlanInput);
    }
  }
  setupBoxClickListeners() {
    [this.oneTimeBox, this.subscriptionBox].forEach((t) => {
      if (t) {
        t.addEventListener("click", ($) => {
          if (!this.isCheckbox || !$.target.closest(".subscription__frequency")) {
            if (this.isCheckbox) {
              let i = t.classList.contains("subscription__box--selected");
              this.isSubSelected = !i;
              t.classList.toggle("subscription__box--selected");
              t.dataset.selected = !i;
              this.sellingPlanInput.value = i ? "" : this.selectedPlanId;
            } else {
              this.isSubSelected = t.dataset.type === "subscription";
              this.oneTimeBox?.classList.remove("subscription__box--selected");
              this.subscriptionBox?.classList.remove("subscription__box--selected");
              this.oneTimeBox?.setAttribute("data-selected", "false");
              this.subscriptionBox?.setAttribute("data-selected", "false");
              t.classList.add("subscription__box--selected");
              t.dataset.selected = "true";
              this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : "";
            }
            if (this.updatePrices) {
              this.updateAllPrices();
            }
          }
        });
      }
    });
  }
  updateAllPrices() {
    this.basePrice = parseInt(this.dataset.basePrice);
    this.baseComparePrice = parseInt(this.dataset.baseComparePrice);
    if (this.quantityBreaks) {
      if (this.isSubSelected) {
        this.quantityBreaks.subDiscountType = this.discountType;
        this.quantityBreaks.subDiscount = this.discountValue;
      } else {
        this.quantityBreaks.subDiscountType = null;
        this.quantityBreaks.subDiscount = 0;
      }
      this.quantityBreaks.updateDisplayedPdpPrices();
      this.quantityBreaks.updateInnerPrices();
    } else {
      let t = this.applySubTo(this.basePrice);
      updatePdpPrices(t, this.baseComparePrice, this.dataset.section, this.moneyFormat);
    }
    let x = document.querySelector(
      'variant-selects[data-section="' +
        this.sectionId +
        '"][data-has-quantity-breaks-picker="true"]',
    );
    if (x && x.updateQuantityBreaksPickerPrices) {
      x.updateQuantityBreaksPickerPrices(
        this.isSubSelected ? this.discountType : null,
        this.isSubSelected ? this.discountValue : 0,
        this.moneyFormat,
      );
    }
    this.renderSubTexts();
  }
  applySubTo($, t = false) {
    if (this.isSubSelected || t) {
      if (this.discountType === "fixed_amount") {
        return Math.max(0, $ - this.discountValue);
      }
      if (this.discountType === "percentage") {
        return Math.round(($ * (100 - this.discountValue)) / 100);
      }
      if (this.discountType === "price") {
        return this.discountValue;
      }
    }
    return $;
  }
  setupFrequencyListeners() {
    this.frequencyRadios.forEach((t) => {
      t.addEventListener("change", ($) => {
        this.applyFrequencyNode($.currentTarget);
      });
    });
    if (this.frequencySelect) {
      this.frequencySelect.addEventListener("change", () => {
        let x = this.frequencySelect.selectedOptions?.[0];
        if (x) {
          this.applyFrequencyNode(x);
        }
      });
    }
  }
  applyFrequencyNode($) {
    this.selectedPlanId = $.dataset.sellingPlanId;
    this.discountType = $.dataset.discountType || this.discountType;
    this.discountValue = $.dataset.discountValue
      ? parseInt($.dataset.discountValue, 10)
      : this.discountValue;
    if (this.subscriptionBox?.classList.contains("subscription__box--selected")) {
      this.sellingPlanInput.value = this.selectedPlanId || "";
    }
    if (this.updatePrices) {
      this.updateAllPrices();
    }
  }
  computeSubPrices($ = true) {
    let x = this.basePrice;
    let e = this.baseComparePrice;
    if (this.quantityBreaks && this.displayedPrices !== "unit") {
      x = this.quantityBreaks.offerPrices["offer_" + this.quantityBreaks.selectedOffer].price;
      e =
        this.quantityBreaks.offerPrices["offer_" + this.quantityBreaks.selectedOffer].compare_price;
      if (this.displayedPrices == "unit_with_discount") {
        x /= this.quantityBreaks.selectedQuantity;
        e /= this.quantityBreaks.selectedQuantity;
      }
    }
    if ($) {
      x = this.applySubTo(x, true);
    }
    let i = this.subscriptionName;
    let s = Math.max(0, e - x);
    let a = e > 0 ? Math.round((s * 100) / e) : 0;
    return {
      price: x,
      comparePrice: e,
      amount_saved: s,
      amount_saved_rounded: Math.round(s / 100) * 100,
      percentage_saved: a,
      subscription_name: i,
    };
  }
  renderSubTexts() {
    if (this.subBoxTexts.length > 0) {
      let {
        price: t,
        compare_price: x,
        amount_saved: e,
        amount_saved_rounded: i,
        percentage_saved: s,
        subscription_name: a,
      } = this.computeSubPrices();
      this.updatePriceTexts(this.subBoxTexts, t, x, e, i, s, a);
    }
    if (this.updatePricesFromQtyBreaks) {
      this.renderOneTimeTexts();
    }
  }
  renderOneTimeTexts() {
    if (this.oneTimeBoxTexts.length > 0) {
      let {
        price: t,
        compare_price: x,
        amount_saved: e,
        amount_saved_rounded: i,
        percentage_saved: s,
        subscription_name: a,
      } = this.computeSubPrices(false);
      this.updatePriceTexts(this.oneTimeBoxTexts, t, x, e, i, s, a);
    }
  }
  updatePriceTexts($, t, x, e, i, s, a) {
    let n = ($) => formatMoney($, this.moneyFormat, true);
    $.forEach(($) => {
      let h = $.dataset.text || "";
      h = h
        .replaceAll("[price]", n(t))
        .replaceAll("[compare_price]", n(x))
        .replaceAll("[amount_saved]", n(e))
        .replaceAll("[amount_saved_rounded]", n(i))
        .replaceAll("[percentage_saved]", String(s) + "%")
        .replaceAll("[subscription_name]", a || "");
      $.innerHTML = h;
      if ($.classList.contains("subscription__compare-price")) {
        $.classList.toggle("hidden", !(x > t));
      }
    });
  }
  hydrateFromExternalHTML($) {
    let x = ($) => {
      let x = $.querySelector(".subscription__select .select__select");
      let e = $.querySelectorAll(".subscription__frequency-input");
      if (x) {
        return {
          type: "select",
          count: x.options.length,
          index: x.selectedIndex >= 0 ? x.selectedIndex : 0,
        };
      }
      if (e.length) {
        let i = Array.from(e).findIndex(($) => $.checked);
        return {
          type: "radio",
          count: e.length,
          index: i >= 0 ? i : 0,
        };
      }
      return {
        type: "none",
        count: 0,
        index: 0,
      };
    };
    let e = x(this);
    let i = this.isSubSelected;
    this.dataset.firstSellingPlanId = $.dataset.firstSellingPlanId ?? "";
    this.dataset.subscriptionName = $.dataset.subscriptionName ?? "";
    this.dataset.discountType = $.dataset.discountType ?? "";
    this.dataset.discountValue = $.dataset.discountValue ?? "0";
    let s = $.querySelector(".subscription__wrapper");
    let a = this.querySelector(".subscription__wrapper");
    if (s && a) {
      a.replaceWith(s);
    }
    this.oneTimeBox = this.querySelector('[data-type="one_time"]');
    this.oneTimeBoxTexts = this.querySelectorAll(".one-time-price-update");
    this.subscriptionBox = this.querySelector('[data-type="subscription"]');
    this.subBoxTexts = this.querySelectorAll(".sub-price-update");
    this.frequencySelect = this.querySelector(".subscription__select .select__select");
    this.frequencyRadios = this.querySelectorAll(".subscription__frequency-input");
    let r = x(this);
    let n = 0;
    if (e.type !== "none" && r.type !== "none" && e.count === r.count) {
      n = Math.max(0, Math.min(e.index, r.count - 1));
    }
    if (r.type === "select" && this.frequencySelect) {
      this.frequencySelect.selectedIndex = n;
    } else if (r.type === "radio" && this.frequencyRadios.length) {
      this.frequencyRadios.forEach(($, x) => {
        $.checked = x === n;
      });
    }
    let l = null;
    if (this.frequencySelect) {
      l = this.frequencySelect.selectedOptions?.[0] || this.frequencySelect.options?.[0] || null;
    } else if (this.frequencyRadios.length) {
      l = Array.from(this.frequencyRadios).find(($) => $.checked) || this.frequencyRadios[0];
    }
    this.selectedPlanId = l?.dataset.sellingPlanId || this.dataset.firstSellingPlanId || "";
    if (l) {
      this.applyFrequencyNode(l);
    } else {
      this.selectedPlanId = this.dataset.firstSellingPlanId || "";
      this.discountType = this.dataset.discountType || "";
      this.discountValue = parseInt(this.dataset.discountValue || "0", 10);
    }
    if (i && this.subscriptionBox) {
      this.subscriptionBox.classList.add("subscription__box--selected");
      this.subscriptionBox.setAttribute("data-selected", "true");
      this.oneTimeBox?.classList.remove("subscription__box--selected");
      this.oneTimeBox?.setAttribute("data-selected", "false");
      this.isSubSelected = true;
      this.sellingPlanInput.value = this.selectedPlanId || "";
    } else {
      this.subscriptionBox?.classList.remove("subscription__box--selected");
      this.subscriptionBox?.setAttribute("data-selected", "false");
      if (this.oneTimeBox) {
        this.oneTimeBox.classList.add("subscription__box--selected");
        this.oneTimeBox.setAttribute("data-selected", "true");
      }
      this.isSubSelected = false;
      this.sellingPlanInput.value = "";
    }
    this.setupBoxClickListeners();
    this.setupFrequencyListeners();
    if (this.updatePrices) {
      this.updateAllPrices();
    } else {
      this.renderSubTexts();
    }
  }
}
function updatePdpPrices($, t, x, e) {
  let s = formatMoney($, e);
  let a = formatMoney(t, e);
  let r = t > $;
  let n = document.querySelectorAll(".price-" + x);
  n.forEach((x) => {
    x.classList.toggle("price--on-sale", r);
    x.querySelector(".price__regular .price-item--regular").innerHTML = s;
    x.querySelector(".price__sale .price-item--sale").innerHTML = s;
    if (r) {
      let l = x.querySelector(".price__sale .price-item--regular");
      if (l) {
        l.innerHTML = a;
      }
      let h = x.querySelector(".badge__percentage-saved");
      if (h) {
        h.innerHTML = Math.round(((t - $) * 100) / t);
      }
      let c = x.querySelector(".badge__money-saved");
      if (c) {
        let d = formatMoney(t - $, e, true);
        c.innerHTML = d;
      }
    }
  });
  let l = document.querySelectorAll(".main-atc-price-span-" + x);
  l.forEach(($) => {
    $.innerHTML = s;
  });
}
// ponytail: metafieldPoly() removed - it was the vendor licence enforcement
// (remote check + new Function() on the response + kill-switch). Nothing called it
// after the gate above was removed.
function updateVariantStatuses($, t, x = false) {
  t.forEach((e, i) => {
    if (i === 0) {
      return;
    }
    let a = [...e.querySelectorAll("option")];
    let r = t[i - 1].querySelector(":checked").value;
    let n = $.filter(($) => $.available && $["option" + i] === r).map(($) => $["option" + (i + 1)]);
    let l = $.filter(($) => $["option" + i] === r).map(($) => $["option" + (i + 1)]);
    a.forEach(($) => {
      $.classList.remove("unavailable", "non-existent");
      $.removeAttribute("disabled");
      $.removeAttribute("hidden");
      if (l.includes($.getAttribute("value"))) {
        if (n.includes($.getAttribute("value"))) {
          $.innerText = $.getAttribute("value");
        } else {
          $.innerText = window.variantStrings.unavailable_with_option.replace(
            "[value]",
            $.getAttribute("value"),
          );
          $.classList.add("unavailable");
          if (x) {
            $.setAttribute("disabled", "");
            $.setAttribute("hidden", "");
          }
        }
      } else {
        $.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          $.getAttribute("value"),
        );
        $.classList.add("non-existent");
        $.setAttribute("disabled", "");
        $.setAttribute("hidden", "");
      }
    });
  });
}
function findAvailableVariant($, t, x = true, e = false, i = false) {
  for (let a = t.length - 1; a >= 0; a--) {
    let r = x
      ? $.querySelector(".product-form__input:nth-child(" + (a + 1) + ")")
      : $.querySelectorAll(".select")[a];
    let n = x ? r.querySelector(".product-form__input__type").dataset.type : "dropdown";
    let l =
      n === "dropdown" ? r.querySelectorAll("option") : r.querySelectorAll('input[type="radio"]');
    let h = Array.from(l).findIndex(($) => $.value === t[a]);
    let c = false;
    while (h < l.length - 1) {
      h++;
      let d = l[h];
      if (
        (!e || !d.classList.contains("non-existent")) &&
        (!i || !d.classList.contains("unavailable"))
      ) {
        t[a] = d.value;
        c = true;
        break;
      }
    }
    if (!c) {
      for (h = Array.from(l).findIndex(($) => $.value === t[a]); h > 0;) {
        h--;
        let o = l[h];
        if (
          (!e || !o.classList.contains("non-existent")) &&
          (!i || !o.classList.contains("unavailable"))
        ) {
          t[a] = o.value;
          c = true;
          break;
        }
      }
    }
    if (c) {
      if (n === "dropdown") {
        r.querySelector(".select__select").value = t[a];
      } else {
        r.querySelector('input[type="radio"][value="' + t[a] + '"]').checked = true;
      }
      $.dispatchEvent(new Event("change"));
      return true;
    }
  }
  return false;
}
function updateGiftGoalInStorage({
  giftHandle: $,
  giftVariantId: t,
  unlockType: x,
  unlockRequirement: e,
  unlockTarget: i,
}) {
  let a = JSON.parse(localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY)) || {};
  if (!$ || !t || !e || !x) {
    return;
  }
  let r = {
    type: x,
    gift_handle: $,
    gift_variant_id: Number(t),
    unlock_product_handle: i || null,
  };
  if (x === "product_variant") {
    if (Array.isArray(e)) {
      r.valid_variants = e.map(($) => String($).toLowerCase().trim());
    } else {
      r.valid_variants = [String(e).toLowerCase().trim()];
    }
  } else {
    r.required_quantity = Number(e);
  }
  a[$] = r;
  localStorage.setItem(GIFTS_LOCAL_STORAGE_KEY, JSON.stringify(a));
}
customElements.define("hdl-subscription-widget", HdlSubscriptionWidget);
class QuantityGifts extends HTMLElement {
  constructor() {
    super();
    this.gifts = this.querySelectorAll(".quantity-gift");
    this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section);
    this.unlockedItems = [];
    this.mainProduct = this.dataset.mainProduct;
    this.cartItems = document.querySelector("cart-drawer-items");
    this.unlockBy = this.dataset.unlockBy === "variant" ? "variant" : "quantity";
    this.initUnlock();
    this.saveLocalStorage = this.dataset.saveLocalStorage === "true";
    if (this.saveLocalStorage && this.unlockBy !== "variant") {
      this.storeLocalStorageData();
    }
  }
  connectedCallback() {
    if (this.unlockBy === "variant") {
      this._variantUnsub = subscribe(PUB_SUB_EVENTS.variantChange, ({ data: t }) => {
        if (t && t.sectionId === this.dataset.section) {
          this.unlockGiftsByVariant(t.variant, false);
        }
      });
    }
  }
  disconnectedCallback() {
    if (this._variantUnsub) {
      this._variantUnsub();
      this._variantUnsub = undefined;
    }
  }
  storeLocalStorageData() {
    this.gifts.forEach((t) => {
      updateGiftGoalInStorage({
        giftHandle: t.dataset.handle,
        giftVariantId: t.dataset.product,
        unlockType: "product_quantity",
        unlockRequirement: t.dataset.quantity,
        unlockTarget: this.mainProduct,
      });
    });
  }
  initUnlock() {
    if (this.unlockBy === "variant") {
      let t = this._readCurrentVariant();
      this.unlockGiftsByVariant(t, true);
      return;
    }
    let x = 1;
    let e = this.mainProduct
      ? document.querySelectorAll(".cart-item--product-" + this.mainProduct)
      : null;
    if (e && e.length) {
      x = 0;
      for (let i = 0; i < e.length; i++) {
        x += parseInt(e[i].dataset.quantity);
      }
    } else if (this.quantityBreaks) {
      x = parseInt(this.quantityBreaks.selectedQuantity);
    } else if (this.quantitySelector) {
      let s = this.quantitySelector.querySelector('input[name="quantity"]');
      x = parseInt(s.value);
    }
    this.unlockGifts(x, true);
  }
  unlockGifts($, t = false) {
    if (this.unlockBy !== "variant") {
      this.unlockedItems = [];
      this.gifts.forEach((t) => {
        if (parseInt(t.dataset.quantity) <= $) {
          t.classList.add("quantity-gift--unlocked");
          t.dataset.unlocked = "true";
          let i = document.querySelector(".cart-item--product-" + t.dataset.handle);
          if (t.dataset.product && !i) {
            this.unlockedItems.unshift(t.dataset.product);
          }
        } else {
          t.classList.remove("quantity-gift--unlocked");
          t.dataset.unlocked = "false";
        }
      });
      if (this.mainProduct && t) {
        this.addRemoveProducts();
      }
    }
  }
  _readCurrentVariant() {
    let t = document.querySelector('variant-selects[data-section="' + this.dataset.section + '"]');
    if (!t) {
      return null;
    }
    if (t.currentVariant) {
      return t.currentVariant;
    }
    let x = [];
    t.querySelectorAll(".product-form__input").forEach((t) => {
      let i = t.querySelector(".product-form__input__type");
      let s = i ? i.dataset.type : null;
      let a;
      if (s === "dropdown" || s === "dropdwon") {
        let r = t.querySelector(".select__select");
        a = r ? r.value : undefined;
      } else {
        let n = t.querySelector('input[type="radio"]:checked');
        a = n ? n.value : undefined;
      }
      if (a !== undefined) {
        x.push(a);
      }
    });
    try {
      let e = t.querySelector('[type="application/json"]');
      if (!e) {
        return null;
      }
      let i = JSON.parse(e.textContent);
      return (
        i.find(
          (t) =>
            Array.isArray(t.options) &&
            t.options.length === x.length &&
            t.options.every(($, t) => $ === x[t]),
        ) || null
      );
    } catch (s) {
      return null;
    }
  }
  _getOptionOrders() {
    let t = document.querySelector('variant-selects[data-section="' + this.dataset.section + '"]');
    if (!t) {
      return null;
    }
    try {
      let x = t.querySelector('[type="application/json"]');
      if (!x) {
        return null;
      }
      let e = JSON.parse(x.textContent);
      let i = {
        option1: [],
        option2: [],
        option3: [],
      };
      e.forEach((t) => {
        ["option1", "option2", "option3"].forEach(($) => {
          let s = t[$];
          if (s != null) {
            let a = String(s).toLowerCase().trim();
            if (!i[$].includes(a)) {
              i[$].push(a);
            }
          }
        });
      });
      return i;
    } catch (s) {
      return null;
    }
  }
  unlockGiftsByVariant($, t = false) {
    this.unlockedItems = [];
    if (!$) {
      this.gifts.forEach(($) => {
        $.classList.remove("quantity-gift--unlocked");
        $.dataset.unlocked = "false";
        if (this.saveLocalStorage) {
          removeLocalStorageGift({
            gift_handle: $.dataset.handle,
          });
        }
      });
      if (this.mainProduct && t) {
        this.addRemoveProducts();
      }
      return;
    }
    let e = this._getOptionOrders();
    let i = {
      option1: $.option1 ? String($.option1).toLowerCase().trim() : null,
      option2: $.option2 ? String($.option2).toLowerCase().trim() : null,
      option3: $.option3 ? String($.option3).toLowerCase().trim() : null,
    };
    this.gifts.forEach((t) => {
      let a = (t.dataset.variant || "").toLowerCase().trim();
      if (!a.length) {
        t.classList.remove("quantity-gift--unlocked");
        t.dataset.unlocked = "false";
        if (this.saveLocalStorage) {
          removeLocalStorageGift({
            gift_handle: t.dataset.handle,
          });
        }
        return;
      }
      let r = false;
      let n = [];
      if (e) {
        for (let l of ["option1", "option2", "option3"]) {
          let h = e[l];
          let c = h.indexOf(a);
          if (c === -1) {
            continue;
          }
          let d = i[l];
          let o = d ? h.indexOf(d) : -1;
          if (o >= c) {
            r = true;
            n = h.slice(c);
          }
          break;
        }
      }
      if (!e) {
        let f = [
          $.title,
          $.option1,
          $.option2,
          $.option3,
          ...(Array.isArray($.options) ? $.options : []),
        ]
          .filter(($) => $ != null)
          .map(($) => String($).toLowerCase().trim());
        r = f.includes(a);
        n = [a];
      }
      if (r) {
        t.classList.add("quantity-gift--unlocked");
        t.dataset.unlocked = "true";
        let u = document.querySelector(".cart-item--product-" + t.dataset.handle);
        if (t.dataset.product && !u) {
          this.unlockedItems.unshift(t.dataset.product);
        }
        if (this.saveLocalStorage) {
          updateGiftGoalInStorage({
            giftHandle: t.dataset.handle,
            giftVariantId: t.dataset.product,
            unlockType: "product_variant",
            unlockRequirement: n,
            unlockTarget: this.mainProduct,
          });
        }
      } else {
        t.classList.remove("quantity-gift--unlocked");
        t.dataset.unlocked = "false";
        if (this.saveLocalStorage) {
          removeLocalStorageGift({
            gift_handle: t.dataset.handle,
          });
        }
      }
    });
    if (this.mainProduct && t) {
      this.addRemoveProducts();
    }
  }
  addRemoveProducts() {
    if (!this.mainProduct) {
      return;
    }
    let t = document.querySelectorAll(".cart-item--product-" + this.mainProduct);
    this.gifts.forEach((x) => {
      if (t.length && x.dataset.unlocked === "true" && x.dataset.product) {
        this.addToCart(x);
      } else {
        this.removeFromCart(x);
      }
    });
  }
  addToCart($) {
    let x = document.querySelector(".cart-item--product-" + $.dataset.handle);
    if (x) {
      return;
    }
    let e = $.querySelector("product-form");
    if (e && e.handleSubmit) {
      e.handleSubmit();
    }
  }
  removeFromCart($) {
    let x = document.querySelector(".cart-item--product-" + $.dataset.handle);
    if (x && this.cartItems) {
      this.cartItems.updateQuantity(x.dataset.index, 0);
    }
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class QuantityBreakUpsells extends QuantityGifts {
  constructor() {
    super();
    this.offerIndex = this.dataset.offer;
    this.upsells = this.querySelectorAll(".quantity-break__upsell");
    this.boundToggleHandler = this.handleToggle.bind(this);
    this.upsells.forEach((t) => {
      if (t.dataset.toggle === "true") {
        t.addEventListener("click", this.boundToggleHandler);
      }
    });
    this.initUnlock();
    if (this.saveLocalStorage) {
      this.storeLocalStorageData();
    }
  }
  storeLocalStorageData() {
    if (this.upsells) {
      this.upsells.forEach((t) => {
        if (t.dataset.type === "gift") {
          updateGiftGoalInStorage({
            giftHandle: t.dataset.handle,
            giftVariantId: t.dataset.product,
            unlockType: "product_quantity",
            unlockRequirement: t.dataset.minQuantity,
            unlockTarget: this.dataset.mainProduct,
          });
        }
      });
    }
  }
  disconnectedCallback() {
    this.upsells.forEach((t) => {
      if (t.dataset.toggle === "true") {
        t.removeEventListener("click", this.boundToggleHandler);
      }
    });
  }
  unlockGifts($, t = false) {
    this.unlockedItems = [];
    if (this.upsells) {
      this.upsells.forEach((t) => {
        let i = parseInt(t.dataset.minQuantity || 0);
        let s = t.dataset.selected === "true";
        let a = $ >= i && s;
        t.dataset.unlocked = a.toString();
        t.classList.toggle("quantity-gift--unlocked", a);
        let r = document.querySelector(".cart-item--product-" + t.dataset.handle);
        if (a && t.dataset.product && !r) {
          let n = t.dataset.toggle === "true";
          let l = t.dataset.selected === "true";
          if (!n || (n && l)) {
            this.unlockedItems.unshift(t.dataset.product);
          }
        }
      });
      if (this.mainProduct && t && this.dataset.lastOffer === this.dataset.offer) {
        this.addRemoveProducts();
      }
    }
  }
  addRemoveProducts() {
    if (!this.mainProduct) {
      return;
    }
    let t = document.querySelectorAll(".cart-item--product-" + this.mainProduct);
    let x = [];
    let e = [];
    this.upsells.forEach((i) => {
      let a = document.querySelector(".cart-item--product-" + i.dataset.handle);
      let r = i.dataset.unlocked === "true";
      if (t.length) {
        if (r && !a) {
          x.push(i);
        } else if (!r && a) {
          e.push(i);
        }
      } else if (a) {
        e.push(i);
      }
    });
    if (e.length) {
      this.removeFromCart(e[0]);
    } else if (x.length) {
      this.addToCart(x[0]);
    }
  }
  handleToggle($) {
    let x = $.currentTarget;
    let e = x.dataset.selected === "true";
    x.dataset.selected = (!e).toString();
    this.syncUpsellAcrossOffers(x.dataset.handle, !e);
    this.syncCart(x.dataset.handle, !e, x);
  }
  syncUpsellAcrossOffers($, t) {
    let e = document.querySelectorAll("quantity-break-upsells");
    e.forEach((e) => {
      e.querySelectorAll('.quantity-break__upsell[data-handle="' + $ + '"]').forEach(($) => {
        $.dataset.selected = t.toString();
      });
    });
  }
  syncCart($, t, x) {
    let i = document.querySelector(".cart-item--product-" + $);
    if (this.cartItems) {
      if (t && !i) {
        this.addToCart(x);
      } else if (!t && i) {
        this.removeFromCart(x);
      }
    }
  }
}
customElements.define("quantity-break-upsells", QuantityBreakUpsells);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector(".upsell__image__img");
    this.toggleBtn = this.querySelector(".upsell-toggle-btn");
    this.variantSelects = this.querySelector(".upsell__variant-picker");
    this.variantSelectElements = this.querySelectorAll(".select__select");
    this.jsonData = this.querySelector('[type="application/json"]');
    this.productForm = this.querySelector("product-form");
    if (this.productForm) {
      this.idInput = this.productForm.querySelector('[name="id"]');
    }
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.price = parseInt(this.dataset.price);
      this.comparePrice = parseInt(this.dataset.comparePrice);
      this.priceSpan = this.querySelector(".upsell__price .regular-price");
      this.comparePriceSpan = this.querySelector(".upsell__price .compare-price");
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
      this.isMainOfferItem = this.dataset.mainOfferItem === "true";
      if (this.isMainOfferItem) {
        this.mainOfferContainer = document.querySelector(
          "#MainBundleOffer-" + this.dataset.section,
        );
      }
    }
    if (this.toggleBtn) {
      this.toggleBtn.addEventListener("click", this.handleToggle.bind(this));
    }
    if (this.variantSelects) {
      this.variantSelects.addEventListener("change", this.handleSelectChange.bind(this));
    }
  }
  handleToggle($) {
    if (
      $.target.nodeName.toLowerCase() !== "select" &&
      $.target.nodeName.toLowerCase() !== "option"
    ) {
      if (this.dataset.selected === "true") {
        this.dataset.selected = "false";
      } else {
        this.dataset.selected = "true";
      }
    }
  }
  handleSelectChange($) {
    let x = $.currentTarget;
    let e = Array.from(x.querySelectorAll("select"), ($) => $.value);
    let i = this.getVariantData().find(($) => {
      return !$.options.map(($, t) => e[t] === $).includes(false);
    });
    let s = this.getVariantData().filter(($) => x.querySelector(":checked").value === $.option1);
    let a = [...x.querySelectorAll("select")];
    updateVariantStatuses(s, a, this.skipUnavailable);
    if (!i) {
      if (this.skipNonExistent) {
        findAvailableVariant(x, e, false, true, this.skipUnavailable);
      }
      return;
    }
    if (!this.skipUnavailable || !!i.available || !findAvailableVariant(x, e, false, true, true)) {
      if (this.updatePrices) {
        this.price = i.price * this.percentageLeft - this.fixedDiscount;
        this.comparePrice = i.price;
        if (i.compare_at_price && i.compare_at_price > i.price) {
          this.comparePrice = i.compare_at_price;
        }
        displayPrices(
          this.price,
          this.comparePrice,
          this.priceSpan,
          this.comparePriceSpan,
          this.moneyFormat,
        );
      }
      if (this.image && i.featured_image) {
        this.image.src = i.featured_image.src;
      }
      this.updateId(i.id);
      if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices) {
        this.mainOfferContainer.updateTotalPrices();
      }
    }
  }
  updateId($) {
    this.dataset.id = $;
    if (this.idInput) {
      this.idInput.value = $;
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.cartItems = this.cartDrawer ? this.cartDrawer.querySelector("cart-drawer-items") : null;
    this.classicAddButton = this.querySelector(".upsell__add-btn");
  }
  handleToggle($) {
    if (
      $.target.nodeName.toLowerCase() !== "select" &&
      $.target.nodeName.toLowerCase() !== "option"
    ) {
      if (this.dataset.selected === "true") {
        this.dataset.selected = "false";
        this.removeFromCart();
      } else {
        this.dataset.selected = "true";
        this.addToCart();
      }
    }
  }
  addRemoveFromCart() {
    if (this.dataset.selected !== "true" || this.cartDrawer.classList.contains("is-empty")) {
      this.removeFromCart();
    } else {
      this.addToCart();
    }
  }
  addToCart() {
    let t = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (!t) {
      if (this.toggleBtn) {
        this.toggleBtn.setAttribute("disabled", "");
      }
      this.variantSelectElements.forEach((t) => {
        t.setAttribute("disabled", "");
      });
      this.productForm.handleSubmit();
    }
  }
  removeFromCart() {
    let t = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (t && this.cartItems) {
      if (this.toggleBtn) {
        this.toggleBtn.setAttribute("disabled", "");
      }
      this.variantSelectElements.forEach(($) => {
        $.setAttribute("disabled", "");
      });
      this.cartItems.updateQuantity(t.dataset.index, 0);
    }
  }
  updateId($) {
    this.dataset.id = $;
    this.idInput.value = $;
    if (!this.classicAddButton && this.dataset.selected === "true") {
      if (this.selectTimeout) {
        clearTimeout(this.selectTimeout);
      }
      this.removeFromCart();
      let x = ($) => {
        if ($.detail.handle === "handle") {
          this.addToCart();
          document.removeEventListener("cartQuantityUpdated", x);
        }
      };
      document.addEventListener("cartQuantityUpdated", x);
    }
  }
  getUpdateRequired() {
    let t = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    let x = false;
    if (t && this.dataset.selected === "false") {
      x = true;
    } else if (!t && this.dataset.selected === "true") {
      x = true;
    }
    return x;
  }
}
function displayPrices($, t, x, e, i) {
  if (i) {
    if ($ && x) {
      var a = formatMoney($, i);
      x.innerHTML = a;
    }
    if (t && e) {
      var r = formatMoney(t, i);
      e.innerHTML = r;
      if (t > $) {
        e.classList.remove("hidden");
      } else {
        e.classList.add("hidden");
      }
    }
  }
}
// ponytail: initTrapFocus() removed - misleading name; it was the licence-gate
// predicate (checked <footer data-type>), not focus-trap code. Real focus trapping
// is trapFocus()/removeTrapFocus() above.
function formatMoney($, t, x = false) {
  if (typeof $ == "string") {
    $ = $.replace(".", "");
  }
  var i = "";
  var s = /\{\{\s*(\w+)\s*\}\}/;
  var a = t;
  function r($, t) {
    if (typeof $ == "undefined") {
      return t;
    } else {
      return $;
    }
  }
  function n($, t, e, i) {
    t = r(t, 2);
    e = r(e, ",");
    i = r(i, ".");
    if (isNaN($) || $ == null) {
      return 0;
    }
    var a = ($ = ($ / 100).toFixed(t)).split(".");
    var n = a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + e);
    var l = a[1] ? i + a[1] : "";
    if (x && l === i + "00") {
      l = "";
    }
    return n + l;
  }
  switch (a.match(s)[1]) {
    case "amount":
      i = n($, 2);
      break;
    case "amount_no_decimals":
      i = n($, 0);
      break;
    case "amount_with_comma_separator":
      i = n($, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = n($, 0, ".", ",");
  }
  return a.replace(s, i);
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
    this.saveLocalStorage = this.dataset.saveLocalStorage === "true";
    if (this.saveLocalStorage) {
      this.storeLocalStorageData();
    }
  }
  storeLocalStorageData() {
    if (
      this.dataset.handle &&
      this.dataset.id &&
      this.dataset.mainProduct &&
      this.dataset.requirement &&
      this.dataset.type
    ) {
      updateGiftGoalInStorage({
        giftHandle: this.dataset.handle,
        giftVariantId: this.dataset.id,
        unlockType: this.dataset.type,
        unlockRequirement: Number(this.dataset.requirement),
        unlockTarget: this.dataset.mainProduct,
      });
    }
  }
}
function initToggleUpsells() {
  let t = document.querySelector("cart-drawer");
  if (t) {
    t.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift').forEach((t) => {
      if (t.addRemoveFromCart) {
        t.addRemoveFromCart();
      }
    });
  }
}
customElements.define("cart-drawer-gift", CartDrawerGift);
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super();
    this.offerItems = this.querySelectorAll(".main-offer-item");
    this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.priceSpan = this.querySelector(".bundle-deals__total-price-js");
      this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js");
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
    }
  }
  updateTotalPrices() {
    if (this.updatePrices) {
      var t = 0;
      var x = 0;
      for (let e = 0; e < this.offerItems.length; e++) {
        t += parseInt(this.offerItems[e].price);
        x += parseInt(this.offerItems[e].comparePrice);
      }
      t = t * this.percentageLeft - this.fixedDiscount;
      displayPrices(t, x, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
    }
  }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.fieldName = this.dataset.name;
    this.input = this.querySelector('[type="text"], [type="number"], textarea');
    this.inputRadios = this.querySelectorAll('[type="radio"]');
    this.select = this.querySelector(".select__select");
    this.productForm = document.getElementById("product-form-" + this.dataset.section);
    this.prevValue = this.dataset.defaultValue;
    this.isRequired = this.dataset.required === "true";
    this.isText = true;
    this.notMain = this.dataset.notMain === "true";
    if (this.dataset.type === "select" || this.dataset.type === "pills") {
      this.isText = false;
    }
    this.createInputs();
    if (this.isRequired && this.isText) {
      this.isValid = true;
      this.atcButtons = this.notMain
        ? document.querySelectorAll(".featured-product-atc-" + this.dataset.section)
        : document.querySelectorAll(".main-product-atc");
      this.mainAtcButton = this.productForm.querySelector(
        "#ProductSubmitButton-" + this.dataset.section,
      );
      this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label");
      this.mainAtcBtnError = this.mainAtcButton.querySelector(".main-atc__error");
      this.atcErrorMsg = this.dataset.atcErrorMsg;
      this.mainAtcButton.dataset.requiredFields =
        parseInt(this.mainAtcButton.dataset.requiredFields) + 1;
      if (this.mainAtcBtnError) {
        this.mainAtcBtnError.innerHTML = this.atcErrorMsg;
      }
      this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true";
      this.stickyAtcButton = document.querySelector("#sticky-atc-" + this.dataset.section);
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector(".sticky-atc__label");
        this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error");
        if (this.stickyAtcBtnError) {
          this.stickyAtcBtnError.innerHTML = this.atcErrorMsg;
        }
      }
      this.validateValue(this.prevValue, null);
    }
    if (this.input) {
      this.input.addEventListener("input", this.handleChange.bind(this));
    }
    this.inputRadios.forEach((t) => {
      t.addEventListener("input", this.handleChange.bind(this));
    });
    if (this.select) {
      this.select.addEventListener("change", this.handleChange.bind(this));
    }
  }
  handleChange($) {
    let x = $.target.value.trim();
    if ($.target.checkValidity()) {
      this.prevValue = x;
    } else {
      $.target.value = this.prevValue;
      return;
    }
    this.dataset.value = x;
    this.productFormInput.value = x;
    if (this.isRequired && this.isText) {
      this.validateValue(x, $.target);
    }
  }
  validateValue($, t) {
    let e = $.length > 0;
    if (e === this.isValid) {
      return;
    }
    this.isValid = e;
    if (t) {
      if (this.isValid) {
        t.classList.remove("input--error");
        this.mainAtcButton.dataset.validFields =
          parseInt(this.mainAtcButton.dataset.validFields) + 1;
      } else {
        t.classList.add("input--error");
        this.mainAtcButton.dataset.validFields =
          parseInt(this.mainAtcButton.dataset.validFields) - 1;
      }
    }
    let i = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields;
    let s = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach(($) => {
      if (i && !s) {
        $.removeAttribute("disabled");
      } else {
        $.setAttribute("disabled", "");
      }
    });
    if (this.atcErrorMsg.length !== 0) {
      if (i) {
        this.mainAtcBtnLabel.style.display = "";
        this.mainAtcBtnError.style.display = "none";
        if (this.applyStickyAtcError && this.stickyAtcButton) {
          this.stickyAtcBtnLabel.style.display = "";
          this.stickyAtcBtnError.style.display = "none";
        }
      } else {
        this.mainAtcBtnLabel.style.display = "none";
        this.mainAtcBtnError.style.display = "";
        if (this.applyStickyAtcError && this.stickyAtcButton) {
          this.stickyAtcBtnLabel.style.display = "none";
          this.stickyAtcBtnError.style.display = "";
        }
      }
    }
  }
  createInputs() {
    this.productFormInput = document.createElement("input");
    this.productFormInput.setAttribute("type", "hidden");
    this.productFormInput.setAttribute("name", "properties[" + this.fieldName + "]");
    this.productFormInput.value = this.dataset.defaultValue;
    this.productFormInput.classList.add("hdl-property-input");
    this.productForm.appendChild(this.productFormInput);
  }
}
// ponytail: playMedia() removed - it only stashed the licence token from
// data-animations-type into `serial`, which nothing read.
customElements.define("custom-product-field", CustomProductField);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.secondarySelectSelector = "StickyAtcVariantPicker-";
    this.secondarySelect = document.getElementById(
      "" + this.secondarySelectSelector + this.dataset.section,
    );
    this.isSecondary = false;
    this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true";
    this.prependMedia = this.dataset.disablePrepend != "true";
    this.filtering = this.dataset.hasFiltering === "true";
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    if (this.hasQuantityBreaksPicker) {
      this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle;
      this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages;
    }
    this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (this.currentVariant) {
      if (
        this.skipUnavailable &&
        !this.currentVariant.available &&
        findAvailableVariant(this, this.options, true, true, true)
      ) {
        return;
      }
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    } else {
      this.toggleAddButton(true, "", true);
      if (
        this.skipNonExistent &&
        findAvailableVariant(this, this.options, true, true, this.skipUnavailable)
      ) {
        return;
      }
      this.setUnavailable();
    }
  }
  updateOptions() {
    let t = [];
    this.querySelectorAll(".product-form__input").forEach((x) => {
      let i;
      let s = x.querySelector(".product-form__input__type").dataset.type;
      i =
        s == "dropdown" || s == "dropdwon"
          ? x.querySelector(".select__select").value
          : x.querySelector('input[type="radio"]:checked').value;
      t.push(i);
    });
    this.options = t;
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((t) => {
      return !t.options.map(($, t) => this.options[t] === $).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) {
      return;
    }
    let t = document.querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]');
    t.forEach((t) =>
      t.setActiveMedia(
        this.dataset.section + "-" + this.currentVariant.featured_media.id,
        this.prependMedia,
        this.filtering,
        this.currentVariant,
      ),
    );
    let x = document.querySelector(
      "#ProductModal-" + this.dataset.section + " .product-media-modal__content",
    );
    if (!x) {
      return;
    }
    let e = x.querySelector('[data-media-id="' + this.currentVariant.featured_media.id + '"]');
    x.prepend(e);
  }
  updateURL() {
    if (this.currentVariant && this.dataset.updateUrl !== "false") {
      window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
    }
  }
  updateShareUrl() {
    let t = document.getElementById("Share-" + this.dataset.section);
    if (t && t.updateUrl) {
      t.updateUrl("" + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
    }
  }
  updateVariantInput() {
    let t = document.querySelectorAll(
      "#product-form-" +
        this.dataset.section +
        ", #product-form-installment-" +
        this.dataset.section,
    );
    t.forEach((t) => {
      let e = t.querySelector('input[name="id"]');
      e.value = this.currentVariant.id;
      e.dispatchEvent(
        new Event("change", {
          bubbles: true,
        }),
      );
    });
  }
  updateVariantStatuses() {
    let t = this.variantData.filter((t) => this.querySelector(":checked").value === t.option1);
    let x;
    (x =
      this.isSecondary && this.secondarySelect
        ? [...this.secondarySelect.querySelectorAll(".product-form__input")]
        : [...this.querySelectorAll(".product-form__input")]).forEach((e, i) => {
      if (i === 0) {
        return;
      }
      let a = [...e.querySelectorAll('input[type="radio"], .select__select option')];
      let r = x[i - 1].querySelector(":checked").value;
      let n = t
        .filter(($) => $.available && $["option" + i] === r)
        .map(($) => $["option" + (i + 1)]);
      let l = t.filter(($) => $["option" + i] === r).map(($) => $["option" + (i + 1)]);
      this.setInputAvailability(a, n, l, this.skipNonExistent, this.skipUnavailable);
    });
  }
  setInputAvailability($, t, x, e = false, i = false) {
    $.forEach(($) => {
      $.classList.remove("unavailable", "non-existent", "disabled");
      $.removeAttribute("disabled");
      $.removeAttribute("hidden");
      let r = $.getAttribute("value");
      let n = null;
      if ($.dataset.swatch === "true") {
        n = $.closest(".color-swatch");
      }
      if (n) {
        n.classList.remove("unavailable", "non-existent", "disabled");
      }
      if (x.includes(r)) {
        if (t.includes(r)) {
          if ($.nodeName === "OPTION") {
            $.innerText = r;
          } else {
            $.classList.remove("disabled");
            if (n) {
              n.classList.remove("disabled");
            }
          }
        } else if ($.nodeName === "OPTION") {
          $.innerText = window.variantStrings.unavailable_with_option.replace("[value]", r);
          $.classList.add("unavailable");
          if (i) {
            $.setAttribute("disabled", "");
            $.setAttribute("hidden", "");
          }
        } else {
          $.classList.add("disabled", "unavailable");
          if (n) {
            n.classList.add("disabled", "unavailable");
          }
        }
      } else if ($.nodeName === "OPTION") {
        $.innerText = window.variantStrings.unavailable_with_option.replace("[value]", r);
        $.classList.add("non-existent");
        if (e) {
          $.setAttribute("disabled", "");
          $.setAttribute("hidden", "");
        }
      } else {
        $.classList.add("disabled", "non-existent");
        if (n) {
          n.classList.add("disabled", "non-existent");
        }
      }
    });
  }
  updatePickupAvailability() {
    let t = document.querySelector("pickup-availability");
    if (t) {
      if (this.currentVariant && this.currentVariant.available) {
        if (t.fetchAvailability) {
          t.fetchAvailability(this.currentVariant.id);
        }
      } else {
        t.removeAttribute("available");
        t.innerHTML = "";
      }
    }
  }
  removeErrorMessage() {
    let t = this.closest("section");
    if (!t) {
      return;
    }
    let x = t.querySelector("product-form");
    if (x) {
      x.handleErrorMessage();
    }
  }
  renderProductInfo() {
    let t = this.currentVariant.id;
    let x = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(
      this.dataset.url +
        "?variant=" +
        t +
        "&section_id=" +
        (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
    )
      .then((t) => t.text())
      .then((e) => {
        if (this.currentVariant.id !== t) {
          return;
        }
        let s = new DOMParser().parseFromString(e, "text/html");
        let a = document.getElementById("price-" + this.dataset.section);
        let r = s.getElementById(
          "price-" +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
        );
        let n = document.getElementById("sticky-atc-separate-price-" + this.dataset.section);
        let l = s.getElementById(
          "sticky-atc-separate-price-" +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
        );
        let h = document.getElementById("sticky-atc-price-" + this.dataset.section);
        let c = s.getElementById(
          "sticky-atc-price-" +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
        );
        let d = document.getElementById("sticky-atc-image-" + this.dataset.section);
        if (d && this.currentVariant.featured_image) {
          d.src = this.currentVariant.featured_image.src;
        }
        let o = document.getElementById("main-atc-price-" + this.dataset.section);
        let f = s.getElementById(
          "main-atc-price-" +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
        );
        let u = document.querySelectorAll('[id^="custom-label-' + this.dataset.section + '"]');
        let b = s.querySelectorAll(
          '[id^="custom-label-' +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) +
            '"]',
        );
        let p = s.getElementById(
          "Sku-" +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
        );
        let _ = document.getElementById("Sku-" + this.dataset.section);
        let m = s.getElementById(
          "Inventory-" +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
        );
        let y = document.getElementById("Inventory-" + this.dataset.section);
        if (a && r) {
          a.innerHTML = r.innerHTML;
        }
        if (n && l) {
          n.innerHTML = l.innerHTML;
        }
        if (h && c) {
          h.innerHTML = c.innerHTML;
        }
        if (f && o) {
          o.innerHTML = f.innerHTML;
        }
        if (u && b) {
          for (var g = 0; g < u.length; g++) {
            u[g].innerHTML = b[g].innerHTML;
          }
        }
        if (m && y) {
          y.innerHTML = m.innerHTML;
        }
        if (p && _) {
          _.innerHTML = p.innerHTML;
          _.classList.toggle("visibility-hidden", p.classList.contains("visibility-hidden"));
        }
        if (this.QuantityBreaks) {
          let v = s.getElementById(
            "quantity-breaks-" +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          );
          let S = this.QuantityBreaks.querySelectorAll(".dynamic-price");
          let k = v.querySelectorAll(".dynamic-price");
          for (let T = 0; T < S.length; T++) {
            S[T].innerHTML = k[T].innerHTML;
          }
          if (this.QuantityBreaks.hasVariants) {
            this.QuantityBreaks.variantSelects.forEach(($) => {
              $.dataset.selectedId = this.currentVariant.id;
            });
            let E = this.QuantityBreaks.querySelectorAll(".quantity-break__variant-select");
            let B = v.querySelectorAll(".quantity-break__variant-select");
            for (let C = 0; C < E.length; C++) {
              E[C].innerHTML = B[C].innerHTML;
            }
            this.QuantityBreaks.initVariants();
          }
          if (this.currentVariant.featured_image) {
            this.QuantityBreaks.querySelectorAll(
              ".quantity-break__selector-item__image img",
            ).forEach(($) => {
              $.src = this.currentVariant.featured_image.src;
            });
          }
          if (this.QuantityBreaks.updatePdpPrices) {
            this.QuantityBreaks.dataset.basePrice = v.dataset.basePrice;
            this.QuantityBreaks.labels.forEach(($) => {
              $.dataset.baseComparePrice = v.querySelector(
                'label[data-input="' + $.dataset.input + '"]',
              ).dataset.baseComparePrice;
            });
            this.QuantityBreaks.initOfferPrices(true);
            this.QuantityBreaks.updateInnerPrices();
          }
        }
        let q = document.getElementById("SubscriptionWidget-" + this.dataset.section);
        let I = s.getElementById(
          "SubscriptionWidget-" +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
        );
        if (q) {
          if (I) {
            q.dataset.basePrice = I.dataset.basePrice || "";
            q.dataset.baseComparePrice = I.dataset.baseComparePrice || "";
            let P = (q.dataset.firstSellingPlanId || "") !== (I.dataset.firstSellingPlanId || "");
            if (P && typeof q.hydrateFromExternalHTML === "function") {
              q.hydrateFromExternalHTML(I);
            } else {
              let w = q.querySelectorAll(".one-time-price-update");
              let R = I.querySelectorAll(".one-time-price-update");
              for (let A = 0; A < w.length; A++) {
                w[A].innerHTML = R[A].innerHTML;
              }
              if (q.updatePrices) {
                q.updateAllPrices();
              }
            }
          } else {
            q.classList.add("hidden");
          }
        }
        if (this.hasQuantityBreaksPicker) {
          let U = s.getElementById(
            "variant-selects-" +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          );
          let F = this.querySelectorAll(".dynamic-price");
          let L = U.querySelectorAll(".dynamic-price");
          for (let V = 0; V < F.length; V++) {
            F[V].innerHTML = L[V].innerHTML;
          }
          if (
            this.quantityBreaksPickerStyle === "vertical" &&
            this.quantityBreaksPickerDisplayedImages === "variant_images"
          ) {
            let D = this.querySelectorAll(".quantity-break__image img");
            let M = U.querySelectorAll(".quantity-break__image img");
            for (let Q = 0; Q < D.length; Q++) {
              D[Q].src = M[Q].src;
            }
          }
          let G = U.querySelectorAll(".quantity-break[data-base-price]");
          let H = this.querySelectorAll(".quantity-break");
          for (let N = 0; N < H.length && N < G.length; N++) {
            if (G[N].dataset.basePrice) {
              H[N].dataset.basePrice = G[N].dataset.basePrice;
              H[N].dataset.baseComparePrice = G[N].dataset.baseComparePrice;
            }
          }
          let O = document.getElementById("SubscriptionWidget-" + this.dataset.section);
          if (O && O.isSubSelected && this.updateQuantityBreaksPickerPrices) {
            this.updateQuantityBreaksPickerPrices(O.discountType, O.discountValue, O.moneyFormat);
          }
        }
        if (this.secondarySelect) {
          let W = s.getElementById(
            "" +
              this.secondarySelectSelector +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          );
          if (W) {
            this.secondarySelect.innerHTML = W.innerHTML;
          }
        }
        let X = document.getElementById("price-" + this.dataset.section);
        if (X) {
          X.classList.remove("visibility-hidden");
        }
        this.dataset.options = this.currentVariant.options.join(",");
        if (y) {
          y.classList.toggle("visibility-hidden", m.innerText === "");
        }
        let Z = s.getElementById("ProductSubmitButton-" + x);
        this.toggleAddButton(!Z || Z.hasAttribute("disabled"), window.variantStrings.soldOut);
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: x,
            html: s,
            variant: this.currentVariant,
          },
        });
      });
  }
  toggleAddButton($ = true, t, x = true) {
    let i = document.getElementById("product-form-" + this.dataset.section);
    if (!i) {
      return;
    }
    let s = i.querySelector('[name="add"]');
    if (!s) {
      return;
    }
    let a = document.querySelectorAll(".main-product-atc");
    var r = i.querySelector(".main-atc__label__text");
    r ||= i.querySelector(".main-atc__label");
    let n = i.querySelector(".main-atc-price");
    let l = document.querySelector(".sticky-atc__add_button");
    let h = null;
    let c = null;
    if (l) {
      h = l.querySelector(".sticky-atc__label__text");
      c = l.querySelector(".sticky-atc__button-price");
    }
    if ($) {
      s.setAttribute("disabled", "disabled");
      s.setAttribute("data-unavailable", "true");
      if (t && r) {
        r.textContent = t;
      }
      if (t && h && l.dataset.label) {
        h.textContent = t;
      }
      a.forEach(($) => {
        $.setAttribute("disabled", "disabled");
      });
      if (n) {
        n.classList.add("hidden");
      }
      if (c) {
        c.classList.add("hidden");
      }
    } else {
      s.setAttribute("data-unavailable", "false");
      let d = s.dataset.customLabel ?? window.variantStrings.addToCart;
      if (r) {
        r.textContent = d;
      }
      if (n) {
        n.classList.remove("hidden");
      }
      if (h && l.dataset.label) {
        h.textContent = l.dataset.label;
      }
      if (c) {
        c.classList.remove("hidden");
      }
      if (s.dataset.requiredFields === s.dataset.validFields) {
        s.removeAttribute("disabled");
        a.forEach(($) => {
          $.removeAttribute("disabled");
        });
      }
    }
    if (!x) {
      return;
    }
  }
  setUnavailable() {
    let t = document.getElementById("product-form-" + this.dataset.section);
    if (!t) {
      return;
    }
    let x = t.querySelector('[name="add"]');
    var e = t.querySelector(".main-atc__label__text");
    e ||= t.querySelector(".main-atc__label");
    let i = document.getElementById("price-" + this.dataset.section);
    let s = document.getElementById("Inventory-" + this.dataset.section);
    let a = document.getElementById("Sku-" + this.dataset.section);
    if (x) {
      if (e) {
        e.textContent = window.variantStrings.unavailable;
      }
      if (i) {
        i.classList.add("visibility-hidden");
      }
      if (s) {
        s.classList.add("visibility-hidden");
      }
      if (a) {
        a.classList.add("visibility-hidden");
      }
    }
  }
  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  updateQuantityBreaksPickerPrices($, t, x) {
    if (!this.hasQuantityBreaksPicker) {
      return;
    }
    let i = this.querySelectorAll(".quantity-break");
    if (i.length) {
      i.forEach((i) => {
        if (!i.dataset.basePrice) {
          return;
        }
        let a = parseInt(i.dataset.basePrice);
        let r = parseInt(i.dataset.baseComparePrice) || a;
        let n = a;
        if ($ && t) {
          if ($ === "fixed_amount") {
            n = Math.max(0, a - t);
          } else if ($ === "percentage") {
            n = Math.round((a * (100 - t)) / 100);
          } else if ($ === "price") {
            n = t;
          }
        }
        let l = r - n;
        let h = r > 0 ? Math.round((l / r) * 100) : 0;
        let c = formatMoney(n, x, true);
        let d = formatMoney(r, x, true);
        let o = formatMoney(l, x, true);
        let f = formatMoney(Math.round(l / 100) * 100, x, true);
        let u = i.querySelectorAll(".variant-price-update[data-text]");
        u.forEach(($) => {
          let x = $.dataset.text;
          x = (x = (x = (x = (x = x.replace("[price]", c)).replace("[compare_price]", d)).replace(
            "[amount_saved]",
            o,
          )).replace("[amount_saved_rounded]", f)).replace("[percentage_saved]", h + "%");
          $.innerHTML = x;
        });
        let b = i.querySelector(".quantity-break__compare-price");
        if (b) {
          if (r > n) {
            b.classList.remove("hidden");
          } else {
            b.classList.add("hidden");
          }
        }
      });
    }
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById(
      "" + this.secondarySelectSelector + this.dataset.section,
    );
    this.isSecondary = true;
  }
  updateOptions() {
    this.options = this.querySelector("select").value.split(",");
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById(
      "" + this.secondarySelectSelector + this.dataset.section,
    );
    this.isSecondary = true;
  }
}
customElements.define("secondary-variant-select-separate", SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
  constructor() {
    super();
    this.quickAddSubmit = document.getElementById(this.dataset.section + "-submit");
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updateVariantStatuses();
    if (this.currentVariant) {
      this.updateMedia();
      this.updateVariantInput();
      this.updateQuickAddUrl();
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    } else {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    }
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) {
      return;
    }
    let t = document.getElementById(this.dataset.section + "-image");
    if (!t) {
      return;
    }
    let x = this.currentVariant.featured_media.preview_image;
    let e = x.src.split("?")[0];
    let i = [165, 360, 533, 720, 940, 1066]
      .filter(($) => x.width >= $)
      .map(($) => e + "?width=" + $ + " " + $ + "w")
      .join(", ");
    t.srcset = i + ", " + e + " " + x.width + "w";
    t.src = e + "?width=533";
  }
  updateQuickAddUrl() {
    if (this.currentVariant && this.quickAddSubmit) {
      this.quickAddSubmit.dataset.productUrl =
        this.dataset.url + "?variant=" + this.currentVariant.id;
    }
  }
}
customElements.define("card-variant-selects", CardVariantSelects);
